/**
 * Loan Api
 * 1.0.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "@oazapfts/runtime";
import * as QS from "@oazapfts/runtime/query";
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
    headers: {},
    baseUrl: "/",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type AllocationContract = {
    contractDraftId?: string | null;
    inLAS?: boolean;
    principalAmount?: number;
    maturityYears?: number;
    startDate?: string;
    endDate?: string;
    contractLoanType?: ContractLoanTypeEnum;
    guarantorMaxPrincipalAmount?: number;
    guarantorMaxMaturity?: number;
    guarantorContractLoanTypeOnly?: ContractLoanTypeEnum;
    guarantorLastChangedTime?: string | null;
    customerMaxPrincipalAmount?: number;
    customerMaxMaturity?: number;
    customerContractLoanTypeOnly?: ContractLoanTypeEnum;
    customerLastChangedTime?: string | null;
    projectName?: string | null;
    industryCode?: string | null;
    industryCodeLastChangedTime?: string | null;
    paymentAdviseType?: PaymentAdviseTypes;
    eanId?: string | null;
    paymentAdviseChangeTime?: string | null;
    inActiveDate?: string | null;
};
export type AllocationResponse = {
    allocationId?: number;
    allocationName?: string | null;
    companyId?: string | null;
    originalAmount?: number | null;
    remainingAmount?: number | null;
    remainingAmountAdjusted?: number | null;
    maxTimeToMaturity?: number;
    createDate?: string;
    updateDate?: string | null;
    allocationContracts?: AllocationContract[] | null;
};
export type AllocationRequest = {
    allocationName?: string | null;
    companyId: string;
    originalAmount?: number | null;
    maxTimeToMaturity?: number | null;
    activeUntil?: string | null;
    allocationStatus?: number | null;
};
export type ContractDraftRequest = {
    loanPurpose?: string | null;
    maxPrincipal?: number | null;
    maxMaturity?: number | null;
    productType?: ContractLoanTypeEnum;
};
export type GuarantorListEntry = {
    companyId?: string | null;
    liabilityPercentage?: number | null;
};
export type ContractDraftReleationsResponse = {
    isProRata?: boolean;
    guarantorList?: GuarantorListEntry[] | null;
    updateDate?: string;
};
export type GuarantorResponse = {
    guarantorId?: string | null;
    guarantorName?: string | null;
};
export type GuaranteeRelationRequest = {
    guaranteeType?: GuaranteeType;
    isProRata?: boolean;
    guarantorList?: GuarantorListEntry[] | null;
};
export type EanInformation = {
    eanId?: string | null;
    comment?: string | null;
};
export type PaymentAdviseRequest = {
    paymentAdviseType?: PaymentAdviseTypes;
    eanId?: string | null;
};
export type ContractDraftGuaranteeInformationRequest = {
    maxPrincipal?: number | null;
    maxMaturity?: number | null;
    productType?: string | null;
};
export type ValidationErrorResponse = {
    validationErrors?: string[] | null;
};
export type ConversionContractsRequest = {
    fromContract: string | null;
    toContract: string | null;
};
export type ConversionDraftRequest = {
    eventDate: string;
    eventDescription?: string | null;
    contractsToConvert: ConversionContractsRequest[] | null;
};
export type ConversionDraftResponse = {
    loanEventId: number;
    eventDate: string;
    eventStatus: LoanEventStatus;
    eventDescription?: string | null;
    contractsToConvert: ConversionContractsRequest[] | null;
};
export type LoanSearch = {
    contractId?: string | null;
    companyId?: string | null;
    companyLasId?: string | null;
    principalAmount?: number | null;
    startDate?: string;
    loanPurpose?: string | null;
    notionalAmount?: number;
    maturityDate?: string;
    loantype?: ContractLoanTypeEnum;
    greenLoan?: boolean;
    loanStatus?: ContractStatus;
};
export type LoanSearchResponse = LoanSearch;
export type ErrorResponse = {
    errorMessage?: string[] | null;
};
export type LoanSearchRelation = {
    contractId?: string | null;
    companyLasId?: string | null;
    relationCompanyLasId?: string | null;
    relationCompanyId?: string | null;
    relationType?: string | null;
    liabilityPercentage?: number | null;
    liabilityAmount?: number | null;
};
export type LoanSearchRelationResponse = LoanSearchRelation;
export type HolidayResponse = {
    startDate?: string;
    endDate?: string;
    holidayDates: string[] | null;
};
export type InterestSheetCalculation = {
    baseContract?: object;
    contractLoanType: ContractLoanTypeEnum;
    amortizationProfile: AmortizationProfile;
    paymentFreq: PaymentFreqEnum;
    yearsToMaturity: number;
    yearsWithFixedRate: number;
    interest?: number;
    spread?: number | null;
};
export type InterestSheetPricing = {
    contractLoanType: ContractLoanTypeEnum;
    interestConvension: InterestConvensionEnum;
    paymentFreq: PaymentFreqEnum;
    interestRate: number;
    kkSpread?: number | null;
    isLeasing?: boolean;
};
export type InterestSheetResponse = {
    interestSheetCalculations: InterestSheetCalculation[] | null;
    interestSheetPricings: InterestSheetPricing[] | null;
    baseCalculationTime: string;
    calculationTime: string;
};
export type AmortListResponse = {
    valueDate?: string;
    dueDate?: string;
    repayment?: number | null;
    interest?: number | null;
    margin?: number | null;
    additionalPayment?: number | null;
    payment?: number | null;
    notionalAmount?: number | null;
    notifiedDate?: string | null;
    knownInterest?: boolean;
    interestRateStatus?: InterestRateStatus;
};
export type TimeMeasure = {
    years?: number;
    months?: number;
    days?: number;
};
export type FixedInterestOptions = {
    cheapest?: FixedInterestPeriodType;
    toMaturity?: FixedInterestPeriodType;
    years: number[] | null;
};
export type LoanInfoResponse = {
    contractId?: string | null;
    companyId?: string | null;
    companyLasId?: string | null;
    principalAmount?: number;
    startDate?: string;
    loanPurpose?: string | null;
    industryCode?: string | null;
    notionalAmount?: number;
    maturityDate?: string;
    loanProduct?: ContractLoanTypeEnum;
    sustainableFramework?: SustainableFrameworkType;
    greenLoan?: boolean;
    currency?: CurrencyCode;
    redemptionValue?: number;
    interestRate?: number;
    nextFixingDate?: string | null;
    latestFixingDate?: string | null;
    interestPaymentFrequency?: PaymentFreqEnum;
    amortizationProfile?: AmortizationProfile;
    spread?: number;
    fundingSpread?: number | null;
    agreementDate?: string;
    interestConditionExpiryDate?: string | null;
    renegotiationAmount?: number | null;
    firstInterestDate?: string | null;
    lastInterestDate?: string | null;
    firstInterestDueDate?: string | null;
    lastInterestDueDate?: string | null;
    amortList?: AmortListResponse[] | null;
    timeToMaturity?: TimeMeasure;
    accountingAreaId?: string | null;
    accountingGroupId?: string | null;
    instrumentId?: string | null;
    customerSwap?: string | null;
    marginRate?: number;
    numberOfPayments?: number;
    interestRatePlusSpread?: number | null;
    firstRepayDateUnadjusted?: string | null;
    firstRepayValueDate?: string | null;
    paymentConvention?: AdjustedUnadjustedEnum;
    dayCountConventions?: DayCountConventions;
    paymentAdviseType?: PaymentAdviseTypes;
    ean?: string | null;
    pbs?: string | null;
    firstPayment?: number;
    businessDayConvention?: BusinessDayConventionEnum;
    loanDuration?: TimeMeasure;
    payoutDate?: string | null;
    isPrepaid?: boolean;
    fixedInterestOptions?: FixedInterestOptions;
    isOmsGaeldsBrev?: boolean;
};
export type CalculationInfoResponse = LoanInfoResponse & {
    eventDescription?: EventDescriptionCode;
    repayAmount?: number;
    eventDueDate?: string | null;
    eventValueDate?: string | null;
    changeMethod?: ChangeMethodCode;
    calculationDateTime?: string;
    notionalAmountOnValueDate?: number;
    accruedInterest?: number;
    compensationAmount?: number;
    compensationAmountCalculated?: number;
    compensationAmountReported?: number | null;
    preEventMaturityDate?: string;
    postEventMaturityDate?: string;
    paymentReduction?: number;
    isOnTerm?: boolean;
    timeToMaturityReduction?: TimeMeasure;
    markedDataDateTime?: string;
    firstInstalmentFreeRepaymentDate?: string | null;
    calculationPath?: string | null;
    initialCosts?: number;
    loanDurationYearsRounded?: number | null;
    budgetSecurity?: BudgetSecurity;
    fixedInterestYears?: number | null;
    fixedInterestPeriodType?: FixedInterestPeriodType;
    scrap?: number | null;
    fixedFirstPayment?: number | null;
    averageDuration?: number | null;
    installmentFreeTerms?: number | null;
    effectiveInterestRate?: number | null;
    onTopSpread?: number | null;
    interestConditionStartDate?: string | null;
    preEventRenegotiationRemainingDebt?: number | null;
    preEventInterestRate?: number | null;
    preEventKKSpread?: number | null;
    preEventMarginRate?: number | null;
    firstStandardPaymentAmount?: number | null;
    firstAffectedPaymentDate?: string | null;
};
export type PriceSheetCalculation = {
    contractLoanType: ContractLoanTypeEnum;
    amortizationProfile: AmortizationProfile;
    isLeasing: boolean;
    yearsToMaturity: number;
    yearsWithFixedRate: number | null;
    paymentFreq: PaymentFreqEnum;
    spread: number | null;
    interest: number | null;
    isCheapest?: boolean;
};
export type PriceSheetResponse = {
    priceSheetCalculations: PriceSheetCalculation[] | null;
    baseCalculationTime: string;
    calculationTime: string;
};
export type ExpiringInterestAgreementResponse = {
    contractId: string | null;
    companyId: string | null;
    contactLoanType: ContractLoanTypeEnum;
    expiringDate: string;
    contractHasSwaps?: boolean;
};
export type AmortRecord = {
    paymentDate?: string;
    dueDate?: string;
    principal?: number;
    repayment?: number;
    interestPayment?: number;
    marginPayment?: number;
    extraOrdinaryRepayment?: number;
    payment?: number;
    remainingDebt?: number;
    notifiedDate?: string | null;
    knownInterest?: boolean;
};
export type LoanInfo = {
    contractId?: string | null;
    companyId?: string | null;
    companyLasId?: string | null;
    principalAmount?: number;
    startDate?: string;
    loanPurpose?: string | null;
    industryCode?: string | null;
    notionalAmount?: number;
    maturityDate?: string;
    loanProduct?: ContractLoanTypeEnum;
    sustainableFramework?: SustainableFrameworkType;
    greenLoan?: boolean;
    currency?: CurrencyCode;
    redemptionValue?: number;
    interestRate?: number;
    nextFixingDate?: string | null;
    latestFixingDate?: string | null;
    interestPaymentFrequency?: PaymentFreqEnum;
    amortizationProfile?: AmortizationProfile;
    spread?: number;
    fundingSpread?: number | null;
    agreementDate?: string;
    interestConditionExpiryDate?: string;
    renegotiationAmount?: number | null;
    firstInterestDate?: string | null;
    lastInterestDate?: string | null;
    firstInterestDueDate?: string | null;
    lastInterestDueDate?: string | null;
    amortRecordList?: AmortRecord[] | null;
    timeToMaturity?: TimeMeasure;
    accountingAreaId?: string | null;
    accoutingGroupId?: string | null;
    instrumentId?: string | null;
    customerSwap?: string | null;
    firstPayment?: number;
    loanDuration?: TimeMeasure;
    marginRate?: number;
    numberOfPayments?: number;
    interestRatePlusSpread?: number | null;
    firstRepayDateUnadjusted?: string | null;
    paymentConvention?: AdjustedUnadjustedEnum;
    dayCountConventions?: DayCountConventions;
    paymentAdviseType?: PaymentAdviseTypes;
    ean?: string | null;
    pbs?: string | null;
    businessDayConvention?: BusinessDayConventionEnum;
    isPrepaid?: boolean;
    isOmsGaeldsBrev?: boolean;
};
export type PortfolioInfo = LoanInfo & {
    loanCategory?: LoanCategory;
    nextValueDate?: string | null;
    nonAccruedInterest?: number | null;
    disposableAmount?: number | null;
    interestType?: InterestType;
    bossInfoId?: string | null;
    bossInfoProjectName?: string | null;
    swaps?: string | null;
    swapRelatedContractId?: string | null;
    relation?: Relation;
    legalName?: string | null;
    asOfDate?: string | null;
    liabilityPct?: number | null;
    liabilityAmountDkk?: number | null;
    liabilityType?: LiabilityType;
};
export type PortfolioInfoResponse = {
    asOfDate?: string | null;
    ownerPortfolio?: PortfolioInfo[] | null;
    guaranteePortfolio?: PortfolioInfo[] | null;
    partnershipLiabilityPortfolio?: PortfolioInfo[] | null;
    billReceiverPortfolio?: PortfolioInfo[] | null;
};
export type AggregatedPortfolioInfo = {
    asOfDate?: string;
    relation?: Relation;
    loanCategory?: LoanCategory;
    notionalAmount?: number;
    creditMax?: number | null;
    contractCount?: number;
};
export type AggregatedPortfolioInfoResponse = {
    asOfDate?: string;
    ownerPortfolio?: AggregatedPortfolioInfo[] | null;
    guaranteePortfolio?: AggregatedPortfolioInfo[] | null;
    pathershipLiabilityPortfolio?: AggregatedPortfolioInfo[] | null;
};
export type EligibleLoanResponse = {
    contractId?: string | null;
    loanPurpose?: string | null;
    loanProduct?: ContractLoanTypeEnum;
    sustainableFrameWork?: SustainableFrameworkType;
    notionalAmount?: number;
    interestConditionExpiryDate?: string | null;
    hasSwaps?: boolean;
    maturityDate?: string;
    max_MaturityDate?: string | null;
    principalAmount?: number;
};
export type BasicLoanInfoResponse = {
    contractId?: string | null;
    companyId?: string | null;
    companyLasId?: string | null;
    startDate?: string;
    maturityDate?: string;
    loanProduct?: ContractLoanTypeEnum;
    principalAmount?: number;
    notionalAmount?: number;
    currency?: CurrencyCode;
    agreementDate?: string;
    timeToMaturity?: TimeMeasure;
    loanPurpose?: string | null;
    industryCode?: string | null;
    interestRate?: number;
    interestPaymentFrequency?: PaymentFreqEnum;
    redemptionValue?: number;
    amortizationProfile?: AmortizationProfile;
    nextFixingDateString?: string | null;
};
export type PostingListResponse = {
    notifiedDate?: string | null;
    valueDate?: string;
    paymentTypeString?: string | null;
    paymentAmount?: number;
    creditAmount?: number;
};
export type CreditInfoResponse = BasicLoanInfoResponse & {
    disposableAmount?: number;
    availableAmount?: number;
    accruedInterest?: number;
    accruedPeriodStartDate?: string;
    accrudPeriodEndDate?: string;
    postings?: PostingListResponse[] | null;
    marginRate?: number;
    initialCosts?: number;
    firstInterestDate?: string;
    loanDuration?: TimeMeasure;
};
export type CreditRecalculateInterestRequest = {
    interestRate: number;
    nextFixingDate?: string | null;
    fixedForever?: boolean;
};
export type CreditMaxChangeRequest = {
    date: string;
    creditMax: number;
};
export type CreditRepaymentRequest = {
    date: string;
    amount: number;
};
export type CreditDrawRequest = {
    date: string;
    amount: number;
};
export type CreditRecalculateRequest = {
    contractNumber?: string | null;
    runningDate: string;
    rollingDay: number;
    interestPaymentFrequency: PaymentFreqEnum;
    interestConvension: InterestConvensionEnum;
    maturityDate: string;
    creditMax: number;
    remainingDebt: number;
    amortizationProfile: AmortizationProfile;
    interests?: CreditRecalculateInterestRequest[] | null;
    futureCreditMaxChanges?: CreditMaxChangeRequest[] | null;
    financeInterestFromCredit?: boolean;
    repaymentReducesCreditMax?: boolean;
    futureRepayments?: CreditRepaymentRequest[] | null;
    futureDraws?: CreditDrawRequest[] | null;
};
export type PaymentProperties = {
    loadedDate?: string;
    paymentCategory?: string | null;
    paymentType?: InterestDetailedPaymentType;
    readingDate?: string | null;
    transactionDate?: string;
    referenceInterest?: string | null;
    referenceInterestStart?: string | null;
    referenceInterestEnd?: string | null;
    meansOfPayment?: string | null;
    bankAccount?: string | null;
    accountingDate?: string;
};
export type AbsolutePayment = {
    subContractNo?: number;
    dueDate?: string;
    valueDate?: string;
    nominalAmount?: number;
    netAmount?: number;
    remainingDebt?: number;
    discountFactor?: number;
    isLocked?: boolean;
    notifiedDate?: string | null;
    modificationState?: ModificationStateEnum;
    paymentProperties?: PaymentProperties;
    alternativeOrder?: number;
};
export type AdditionalPayment = AbsolutePayment & {
    additionalPaymentType?: AdditionalPaymentTypeEnum;
};
export type CreditRecalculateBatchRequest = {
    calculationPath: string | null;
    requests?: CreditRecalculateRequest[] | null;
};
export type RedemptionMarketValueBatchRequest = {
    contractNumbers: string[];
    redemptionDate: string;
};
export type RedemptionMarketValueResponse = {
    contractId: string | null;
    redemptionDate?: string;
    valueDate?: string | null;
    redemptionValue?: number | null;
    marketValue?: number | null;
    errorMessage?: string | null;
};
export type FirstInterestPaymentDateResponse = {
    validDates?: string[] | null;
};
export type LoanDatesRequest = {
    contractIds?: string[] | null;
};
export type LoanDateResponse = {
    contractId?: string | null;
    status?: LoanDateStatus;
    payoutDate?: string | null;
};
export type LoanDatesError = {
    code?: string | null;
    message?: string | null;
    actualCount?: number | null;
    maxCount?: number | null;
    traceId?: string | null;
};
export type TermDate = {
    dueDate?: string;
    remainingDebt?: number | null;
    notifiedDate?: string | null;
};
export type InTermDate = TermDate & {
    valueDate?: string;
};
export type OutOfTermDate = TermDate;
export type AvailableTermDates = {
    lastNotifiedPaymentDate?: string | null;
    inTermDates?: InTermDate[] | null;
    outOfTermDates?: OutOfTermDate[] | null;
};
export type PartialRedemptionTermDateResponse = AvailableTermDates;
export type ExecutionStatusResponse = {
    data2LASID?: number;
    status?: ExecutionStatusEnum;
    message?: string | null;
    kreditAdvis?: number[] | null;
};
export type IPricing = {
    date?: string;
    value?: number;
};
export type DiscountFactor = IPricing;
export type PricingData = IPricing & {
    curve?: CurveEnum;
    asOfDate?: string;
};
export type Spread = PricingData & {
    termNumber?: number;
};
export type DetailedCalculationInfoResponse = {
    kkVar_AppliedCibor: number | null;
    kkVar_AppliedPrice: number | null;
    kkFast_InterestRatePlain: number | null;
    kkFast_InterestRate: number | null;
    kkFast_Price: number | null;
    discountFactorsPlain: DiscountFactor[] | null;
    discountFactors: DiscountFactor[] | null;
    appliedZeroCouponCurve: string | null;
    appliedSpreadCurve: string | null;
    appliedTenorCurve: string | null;
    appliedForwardTenorCurve: string | null;
    appliedCommitDays: number | null;
    ciborPremiumStructure?: Spread[] | null;
    ciborWeights?: Spread[] | null;
    pricingRule?: PricingRuleEnum;
    fundingPremium?: DiscountFactor;
    ciborNominator?: number;
    ciborDenominator?: number;
    ciborInterestRate?: number;
    loanPortfolio: PortfolioInfo[] | null;
};
export type ValidationResponse = {
    calculationPath: string | null;
    validationError?: LoanValidationEnum;
    validationMessage?: string | null;
};
export type NewLoanRequest = {
    principalValueDate: string;
    interestPaymentFrequency: PaymentFreqEnum;
    principalAmount?: number;
    loanProduct: ContractLoanTypeEnum;
    amortizationProfile?: AmortizationProfile;
    maturityDateUnadjusted?: string;
    fixedInterestPeriodType?: FixedInterestPeriodType;
    fixedInterestYears?: number | null;
    firstPayDateUnadjusted?: string;
    instalmentFreeTerms?: number;
    marginRate?: number;
    marginMethod?: MarginCalculationMethod;
};
export type ConversionRequest = NewLoanRequest & {
    redeemedContracts?: string[] | null;
};
export type NewCreditRequest = NewLoanRequest & {
    creditMaximum?: number;
    interestIncreasesRemainingDebt?: boolean;
};
export type NewLeasingRequest = {
    principalValueDate?: string;
    interestPaymentFrequency: PaymentFreqEnum;
    principalAmount: number;
    loanProduct: ContractLoanTypeEnum;
    amortizationProfile?: AmortizationProfile;
    fixedInterestPeriodType?: FixedInterestPeriodType;
    fixedInterestYears?: number | null;
    instalmentFreeTerms?: number;
    marginRate?: number;
    marginMethod?: MarginCalculationMethod;
    scrap?: number;
    numberOfPayments: number;
    fixedFirstPayment?: number | null;
    prePaid?: boolean;
    onTopSpread?: number | null;
};
export type NewLeasingRequestRead = {
    principalValueDate?: string;
    interestPaymentFrequency: PaymentFreqEnum;
    principalAmount: number;
    loanProduct: ContractLoanTypeEnum;
    amortizationProfile?: AmortizationProfile;
    maturityDateUnadjusted?: string;
    fixedInterestPeriodType?: FixedInterestPeriodType;
    fixedInterestYears?: number | null;
    firstPayDateUnadjusted?: string;
    instalmentFreeTerms?: number;
    marginRate?: number;
    marginMethod?: MarginCalculationMethod;
    scrap?: number;
    numberOfPayments: number;
    fixedFirstPayment?: number | null;
    prePaid?: boolean;
    onTopSpread?: number | null;
};
export type MultipleFixingPeriodsRequest = {
    fixedInterestPeriod: FixedInterestPeriodType[] | null;
    fixedInterestYears: number[] | null;
};
export type MultipleFixingPeriodsResponse = {
    fixedInterestPeriod: FixedInterestPeriodType;
    calculationPath: string | null;
    fixedInterestYears?: number | null;
};
export type PartialRedemptionRequest = {
    amount?: number;
    appliedDate?: string;
    changeMethod?: ChangeMethodCode;
    includeCompensationAmount?: boolean;
};
export type FullRepaymentRequest = {
    appliedDate?: string;
};
export type LoanParametersResponse = {
    loanProduct?: ContractLoanTypeEnum;
    amortizationProfile?: AmortizationProfile;
    interestPaymentFrequency?: PaymentFreqEnum;
    principalAmount?: number | null;
    startDate?: string;
    maturityDateUnadjusted?: string;
    firstRepayValueDate?: string;
    instalmentFreeTerms?: number | null;
    addedSpread?: number | null;
    businessDayConvention?: BusinessDayConventionEnum;
    dayCountConventions?: DayCountConventions;
    paymentConvention?: AdjustedUnadjustedEnum;
    isFirstTermOnExpectedDate?: boolean | null;
    isLastTermOnExpectedDate?: boolean | null;
    firstInterestDueDate?: string;
    interestConditionExpiryDate?: string | null;
    preEventRenegotiationRemainingDebt?: number | null;
    preEventInterestRate?: number | null;
    preEventKKSpread?: number | null;
    preEventMarginRate?: number | null;
};
export type GuarantorLiabilityResponse = {
    companyId: string | null;
    liabilityPercentage: number;
    liabilityAmount: number;
    guaranteeRelation: GuaranteeRelations;
};
export type ExpiringAgreementsResponse = {
    contractId: string | null;
    maturityDate: string;
    isOmsGaeldsBrev: boolean;
};
export type LoanCalculationStateBackfillRun = {
    runId?: string | null;
    status?: LoanCalculationStateBackfillRunState;
    requestedBy?: string | null;
    validateOnly?: boolean;
    fromDate?: string | null;
    toDate?: string | null;
    queuedAtUtc?: string | null;
    startedAtUtc?: string | null;
    finishedAtUtc?: string | null;
    pathsSupplied?: number;
    duplicatesRemoved?: number;
    invalidPaths?: number;
    eligiblePaths?: number;
    calculationsRead?: number;
    outsideDateRangeSkipped?: number;
    blobsMissing?: number;
    stateCreated?: number;
    statePreserved?: number;
    stateMissing?: number;
    stateFailures?: number;
    sourceFailures?: number;
    failureCode?: string | null;
};
export type LoanCalculationStateBackfillStartResult = {
    accepted?: boolean;
    run?: LoanCalculationStateBackfillRun;
};
export type SigningProcessCompleted = {
    contractId: number;
    caseId: string | null;
};
export type ContractDraftSigned = {
    contractId: string | null;
    caseId: string | null;
};
export type CaseClosed = {
    caseId: string | null;
    contractId: string | null;
};
export type PaymentNoticeAdresse = {
    adresse?: string | null;
    journalNummer?: string | null;
    journalLoebenummer?: string | null;
    juridiskNavn?: string | null;
    adresseLinie1?: string | null;
    adresseLinie2?: string | null;
    adresseLinie3?: string | null;
    adresseLinie4?: string | null;
    adresseLinie5?: string | null;
    adresseLinie6?: string | null;
    attention?: string | null;
    telefon?: string | null;
    direkteTelefon?: string | null;
    fax?: string | null;
    email?: string | null;
    seNummer?: string | null;
    postnummer?: string | null;
    bynavn?: string | null;
    land?: string | null;
    bemaerkning?: string | null;
};
export type PaymentNoticePaymentElement = {
    delydelse?: number | null;
    advis?: number;
    betalingsKategori?: string | null;
    betalingsType?: string | null;
    nettoBeloeb?: number;
    sats?: number | null;
    renteDage?: number | null;
    renteBeregnesFra?: string | null;
    renteBeregnesTil?: string | null;
    referenceRente?: string | null;
    aflaesningsDato?: string | null;
    spread?: number | null;
    elementNummer?: number;
    kontoStreng?: string | null;
};
export type PaymentNoticePartPayment = {
    delydelse?: number;
    advis?: number;
    kontraktBen?: string | null;
    bankKonto?: string | null;
    valuta?: string | null;
    retning?: string | null;
    betalesI?: string | null;
    transaktionsKurs?: number | null;
    paymentElements?: PaymentNoticePaymentElement[] | null;
};
export type PaymentNoticeContractLeg = {
    advis?: number;
    kontraktBen?: string | null;
    oprHovedstolBeloeb?: number;
    oprHovedstolValuta?: string | null;
    oprHovedstolDkk?: number | null;
    obligationsRestgaeld?: number | null;
    restgaeldValuta?: string | null;
    gammelRestgaeld?: number | null;
    nyRestgaeld?: number;
    indeks?: string | null;
    indeksDato?: string | null;
    indeksVaerdi?: number | null;
    indeksReguleretBeloeb?: number | null;
    projektNavn?: string | null;
    partPayments?: PaymentNoticePartPayment[] | null;
};
export type PaymentNoticeContract = {
    hovedAdvis?: number | null;
    derivatRelation?: string | null;
    advis?: number;
    advisType?: string | null;
    advisReference?: number | null;
    status?: string | null;
    valoerDato?: string | null;
    forfaldsDato?: string | null;
    periodeFra?: string | null;
    periodeTil?: string | null;
    betalingsform?: string | null;
    pbsNummer?: string | null;
    kontrakt?: string | null;
    kontraktType?: string | null;
    kontraktGruppe?: string | null;
    advisGruppe?: string | null;
    fondsKode?: string | null;
    serieBetegnelse?: string | null;
    kuponRente?: number | null;
    afdelingsBetegnelse?: number | null;
    obligationsType?: string | null;
    obligationsTypeBeskrivelse?: string | null;
    papirKurs?: number | null;
    eanKode?: number | null;
    kontaktPerson?: string | null;
    ordreNummer?: string | null;
    projektNavn?: string | null;
    hovedAdvisReference?: number | null;
    debitorAdresse?: PaymentNoticeAdresse;
    advisAdresse?: PaymentNoticeAdresse;
    kvitterAdresse?: PaymentNoticeAdresse;
    contractLegs?: PaymentNoticeContractLeg[] | null;
};
/**
 * Retrieve Allocation from LAS
 */
export function getAllocationGetallocationByAllocationId(allocationId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AllocationResponse;
    }>(`/allocation/getallocation/${encodeURIComponent(allocationId)}`, {
        ...opts
    }));
}
/**
 * Retrieve Allocation from LAS
 */
export function getAllocationGetallocationbycompanyidByCompanyId(companyId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AllocationResponse[];
    }>(`/allocation/getallocationbycompanyid/${encodeURIComponent(companyId)}`, {
        ...opts
    }));
}
/**
 * Create new allocation
 */
export function postAllocationNewallocation({ allocationName, crmGuid }: {
    allocationName?: string;
    crmGuid?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>(`/allocation/newallocation${QS.query(QS.explode({
        allocationName,
        CRMGuid: crmGuid
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Update existing allocation
 */
export function putAllocationUpdateallocationByAllocationId(allocationId: number, allocationRequest?: AllocationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>(`/allocation/updateallocation/${encodeURIComponent(allocationId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: allocationRequest
    })));
}
/**
 * Create new contract draft
 */
export function postAllocationNewcontractDraft({ allocationId, projectName }: {
    allocationId?: number;
    projectName?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>(`/allocation/newcontractDraft${QS.query(QS.explode({
        allocationId,
        projectName
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Update existing Contract Draft
 */
export function putAllocationUpdatecontractDraftByContractDraftId(contractDraftId: string, contractDraftRequest?: ContractDraftRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>(`/allocation/updatecontractDraft/${encodeURIComponent(contractDraftId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: contractDraftRequest
    })));
}
/**
 * Retrieve Contract Draft from LAS
 */
export function getAllocationGetcontractDraftByContractDraftId(contractDraftId: string, { justActive }: {
    justActive?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AllocationContract;
    }>(`/allocation/getcontractDraft/${encodeURIComponent(contractDraftId)}${QS.query(QS.explode({
        JustActive: justActive
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieve Contract Draft Relations from LAS
 */
export function getAllocationGetcontractdraftrelationsByContractDraftId(contractDraftId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ContractDraftReleationsResponse;
    }>(`/allocation/getcontractdraftrelations/${encodeURIComponent(contractDraftId)}`, {
        ...opts
    }));
}
/**
 * Retrieve guarantor informations for company
 */
export function getAllocationGetcompanyguarantorsByCompanyId(companyId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GuarantorResponse[];
    }>(`/allocation/getcompanyguarantors/${encodeURIComponent(companyId)}`, {
        ...opts
    }));
}
/**
 * Update guarantor relation informations for existing Contract Draft
 */
export function putAllocationUpdateguaranteerelationsforcontractdraftByContractDraftId(contractDraftId: string, guaranteeRelationRequest?: GuaranteeRelationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>(`/allocation/updateguaranteerelationsforcontractdraft/${encodeURIComponent(contractDraftId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: guaranteeRelationRequest
    })));
}
/**
 * Retrieve EAN information for company
 */
export function getAllocationGetCompanyEanByCompanyId(companyId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: EanInformation[];
    }>(`/allocation/getCompanyEAN/${encodeURIComponent(companyId)}`, {
        ...opts
    }));
}
/**
 * Update/InsertPayment Advise informations on existing Contract Draft into LAS
 */
export function putAllocationUpdatecontractdraftpaymentadviseinformationsByContractDraftId(contractDraftId: string, paymentAdviseRequest?: PaymentAdviseRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>(`/allocation/updatecontractdraftpaymentadviseinformations/${encodeURIComponent(contractDraftId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: paymentAdviseRequest
    })));
}
/**
 * Update industry code information on existing Contract Draft into LAS
 */
export function putAllocationUpdatecontractdraftindustrycodeinformationByContractDraftId(contractDraftId: string, { industryCode }: {
    industryCode?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    }>(`/allocation/updatecontractdraftindustrycodeinformation/${encodeURIComponent(contractDraftId)}${QS.query(QS.explode({
        industryCode
    }))}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Update/Insert guarantee requirement for existing Contract Draft into LAS
 */
export function putAllocationUpdatecontractdraftguaranteerequirementByContractDraftId(contractDraftId: string, contractDraftGuaranteeInformationRequest?: ContractDraftGuaranteeInformationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>(`/allocation/updatecontractdraftguaranteerequirement/${encodeURIComponent(contractDraftId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: contractDraftGuaranteeInformationRequest
    })));
}
/**
 * DeActivate ContractDraft
 */
export function putAllocationDeactivatecontractdraftByContractDraftId(contractDraftId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>(`/allocation/deactivatecontractdraft/${encodeURIComponent(contractDraftId)}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * DeActivate Allocation
 */
export function putAllocationDeactivateallocationByAllocationId(allocationId: number, { deActivationDate }: {
    deActivationDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>(`/allocation/deactivateallocation/${encodeURIComponent(allocationId)}${QS.query(QS.explode({
        deActivationDate
    }))}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Sign Contract Draft
 */
export function putAllocationSigncontractdraftByContractDraftId(contractDraftId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    }>(`/allocation/signcontractdraft/${encodeURIComponent(contractDraftId)}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Create new conversion draft
 */
export function postConversiondraftNewconversiondraft(conversionDraftRequest?: ConversionDraftRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    }>("/conversiondraft/newconversiondraft", oazapfts.json({
        ...opts,
        method: "POST",
        body: conversionDraftRequest
    })));
}
/**
 * Update conversion draft
 */
export function putConversiondraftUpdateconversiondraftByLoanEventId(loanEventId: number, conversionDraftRequest?: ConversionDraftRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/conversiondraft/updateconversiondraft/${encodeURIComponent(loanEventId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: conversionDraftRequest
    })));
}
/**
 * Get conversion draft
 */
export function getConversiondraftGetconversiondraftByLoanEventId(loanEventId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ConversionDraftResponse;
    }>(`/conversiondraft/getconversiondraft/${encodeURIComponent(loanEventId)}`, {
        ...opts
    }));
}
/**
 * Delete conversion draft
 */
export function deleteConversiondraftDeleteconversiondraftByLoanEventId(loanEventId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/conversiondraft/deleteconversiondraft/${encodeURIComponent(loanEventId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
/**
 * Create conversion from conversion draft
 */
export function postConversiondraftCreateconversionfromconversiondraftByLoanEventId(loanEventId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText(`/conversiondraft/createconversionfromconversiondraft/${encodeURIComponent(loanEventId)}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Get loan information given information about companyLasId and/or contractId
 */
export function getSearchloans({ companyLasId, contractId, loanNo }: {
    companyLasId?: string;
    contractId?: string;
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LoanSearchResponse[];
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/searchloans${QS.query(QS.explode({
        companyLasId,
        contractId,
        loanNo
    }))}`, {
        ...opts
    }));
}
/**
 * Get information about loan relations given information about companyLasId and/or contractId
 */
export function getSearchloanrelations({ relationCompanyLasId, contractId }: {
    relationCompanyLasId?: string;
    contractId?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LoanSearchRelationResponse[];
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/searchloanrelations${QS.query(QS.explode({
        relationCompanyLasId,
        contractId
    }))}`, {
        ...opts
    }));
}
/**
 * Gets a list of holidays based on usage
 */
export function getCalculationByCalculationPathHolidaysAndHolidayUsage(calculationPath: string, holidayUsage: string, { offset }: {
    offset?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HolidayResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/${encodeURIComponent(calculationPath)}/holidays/${encodeURIComponent(holidayUsage)}${QS.query(QS.explode({
        offset
    }))}`, {
        ...opts
    }));
}
/**
 * Gets a list of new payout holidays based on usage
 */
export function getCalculationByContractIdPayoutholidaysAndHolidayUsage(contractId: string, holidayUsage: string, { newSignedDeadline }: {
    newSignedDeadline?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: HolidayResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/${encodeURIComponent(contractId)}/payoutholidays/${encodeURIComponent(holidayUsage)}${QS.query(QS.explode({
        newSignedDeadline
    }))}`, {
        ...opts
    }));
}
/**
 * Get a freshly calculated interestsheet.
 */
export function getCalculationInterestsheet(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: InterestSheetResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/calculation/interestsheet", {
        ...opts
    }));
}
/**
 * Get a budget model from Oracle.
 */
export function getCalculationBudget({ cRmGuid, subsidizedLoan }: {
    cRmGuid?: string;
    subsidizedLoan?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/budget${QS.query(QS.explode({
        cRMGuid: cRmGuid,
        subsidizedLoan
    }))}`, {
        ...opts
    }));
}
/**
 * Fetch a stored standard calculation from the interest sheet calculation
 */
export function getCalculationFetchstandardcalculationfromstorage({ contactLoanType, amortizationProfile, paymentFreq, yearsToMaturity, principalAmount, yearsFixedInterest }: {
    contactLoanType?: string;
    amortizationProfile?: string;
    paymentFreq?: string;
    yearsToMaturity?: number;
    principalAmount?: number;
    yearsFixedInterest?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CalculationInfoResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/fetchstandardcalculationfromstorage${QS.query(QS.explode({
        contactLoanType,
        amortizationProfile,
        paymentFreq,
        yearsToMaturity,
        principalAmount,
        yearsFixedInterest
    }))}`, {
        ...opts
    }));
}
/**
 * Get a set of freshly calculated leasing interests.
 */
export function getCalculationLeasinginterests(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: InterestSheetPricing[];
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/calculation/leasinginterests", {
        ...opts
    }));
}
/**
 * Get a freshly calculated pricesheet.
 */
export function getCalculationPricesheet(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PriceSheetResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/calculation/pricesheet", {
        ...opts
    }));
}
/**
 * Get contracts with expiring interest agreements
 */
export function getContractsWithexpiringinterestagreement({ maxExpiringDate }: {
    maxExpiringDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExpiringInterestAgreementResponse[];
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/contracts/withexpiringinterestagreement${QS.query(QS.explode({
        maxExpiringDate
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieves loan portfolio for client
 */
export function getCustomerByCompanyIdEodloanportfolio(companyId: string, { date }: {
    date?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PortfolioInfoResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/customer/${encodeURIComponent(companyId)}/eodloanportfolio${QS.query(QS.explode({
        date
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieves aggregated portfolio for customer
 */
export function getCustomerByCompanyIdEodaggregatedportfolio(companyId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AggregatedPortfolioInfoResponse;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/customer/${encodeURIComponent(companyId)}/eodaggregatedportfolio`, {
        ...opts
    }));
}
/**
 * Get the earlist valid filter date for customer page agreement overviews.
 */
export function getCustomerEarliestvalidfilterdate(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/customer/earliestvalidfilterdate", {
        ...opts
    }));
}
/**
 * Get eligable loans based on CompanyId and EventType
 */
export function getEligibleloansByCompanyId(companyId: string, { eventDescription }: {
    eventDescription?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: EligibleLoanResponse[];
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/eligibleloans/${encodeURIComponent(companyId)}${QS.query(QS.explode({
        eventDescription
    }))}`, {
        ...opts
    }));
}
/**
 * Send a stored calculation given a calculation path to LAS for execution. Receive a Boolean indication telling whether LAS accepted the request
 */
export function getExecutecalculationByCalculationPath(calculationPath: string, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/executecalculation/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        loanNo
    }))}`, {
        ...opts
    }));
}
/**
 * Send a stored calculation given a calculation path to LAS for execution. Returns 200 OK on success or 500 Internal Server Error on failure. Be aware that this has changed from the obsolete get endpoint
 */
export function postExecutecalculationByCalculationPath(calculationPath: string, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 500;
        data: string;
    }>(`/executecalculation/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        loanNo
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Fetch a stored calculation by calculation path from storage account
 */
export function getFetchcalculationfromstorageByCalculationPath(calculationPath: string, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CalculationInfoResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/fetchcalculationfromstorage/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        loanNo
    }))}`, {
        ...opts
    }));
}
/**
 * Get credit calculation from storage
 */
export function getFetchcreditcalculationfromstorageByCalculationPath(calculationPath: string, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CreditInfoResponse[];
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/fetchcreditcalculationfromstorage/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        loanNo
    }))}`, {
        ...opts
    }));
}
/**
 * Recalculate credit cashflows from a running date using the provided parameters.
 */
export function postCalculationCreditrecalculate(creditRecalculateRequest?: CreditRecalculateRequest, { calculationPath }: {
    calculationPath?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            [key: string]: (AdditionalPayment)[];
        };
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/creditrecalculate${QS.query(QS.explode({
        calculationPath
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: creditRecalculateRequest
    })));
}
/**
 * Recalculate credit cashflows for a stored calculation path using multiple request scenarios.
 */
export function postCalculationCreditrecalculateBatch(creditRecalculateBatchRequest?: CreditRecalculateBatchRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            [key: string]: (AdditionalPayment)[];
        };
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/calculation/creditrecalculate/batch", oazapfts.json({
        ...opts,
        method: "POST",
        body: creditRecalculateBatchRequest
    })));
}
/**
 * Calculate redemption and market values for multiple contracts on a given redemption date.
 */
export function postContractsRedemptionmarketvalues(redemptionMarketValueBatchRequest?: RedemptionMarketValueBatchRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: RedemptionMarketValueResponse[];
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/contracts/redemptionmarketvalues", oazapfts.json({
        ...opts,
        method: "POST",
        body: redemptionMarketValueBatchRequest
    })));
}
/**
 * Fetch a stored calculation by calculation path from storage account and Receive it as a file
 */
export function getFetchfilefromstorageByCalculationPath(calculationPath: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CalculationInfoResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/fetchfilefromstorage/${encodeURIComponent(calculationPath)}`, {
        ...opts
    }));
}
/**
 * Get a stored calculation's amort profil by calculation path
 */
export function getGetloancalculationdetailsascsvByCalculationPath(calculationPath: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CalculationInfoResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/getloancalculationdetailsascsv/${encodeURIComponent(calculationPath)}`, {
        ...opts
    }));
}
/**
 * Get a list of valid first interest payment dates for credit loans and customers in Greenland.
 */
export function getFirstinterestpaymentdateByStartDate(startDate: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: FirstInterestPaymentDateResponse;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/firstinterestpaymentdate/${encodeURIComponent(startDate)}`, {
        ...opts
    }));
}
/**
 * Get credit information from LAS for a given contractId
 */
export function getGetcreditinfoByContractId(contractId: string, { calculationDate }: {
    calculationDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CreditInfoResponse;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/getcreditinfo/${encodeURIComponent(contractId)}${QS.query(QS.explode({
        CalculationDate: calculationDate
    }))}`, {
        ...opts
    }));
}
export function loanDates(loanDatesRequest?: LoanDatesRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LoanDateResponse[];
    } | {
        status: 400;
        data: LoanDatesError;
    } | {
        status: 500;
        data: ErrorResponse;
    } | {
        status: 503;
        data: LoanDatesError;
    }>("/loan-dates", oazapfts.json({
        ...opts,
        method: "POST",
        body: loanDatesRequest
    })));
}
/**
 * Get loan information from LAS for a given contractId
 */
export function getLoaninfoByContractId(contractId: string, { loanNo, skipA360 }: {
    loanNo?: number;
    skipA360?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LoanInfoResponse;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/loaninfo/${encodeURIComponent(contractId)}${QS.query(QS.explode({
        loanNo,
        SkipA360: skipA360
    }))}`, {
        ...opts
    }));
}
/**
 * Get a list of possible redemption dates for a loan on a given calculation path
 */
export function getPartialredemptiondateByCalculationPath(calculationPath: string, { runDate, loanNo }: {
    runDate?: string;
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PartialRedemptionTermDateResponse;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/partialredemptiondate/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        RunDate: runDate,
        loanNo
    }))}`, {
        ...opts
    }));
}
/**
 * Get a status for executing a calculation from LAS
 */
export function getStatusexecutecalculationByCalculationPath(calculationPath: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExecutionStatusResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/statusexecutecalculation/${encodeURIComponent(calculationPath)}`, {
        ...opts
    }));
}
/**
 * Extract additional information on calculations
 */
export function getCalculationByCalculationPathGetcalculationdetails(calculationPath: string, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DetailedCalculationInfoResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/${encodeURIComponent(calculationPath)}/getcalculationdetails${QS.query(QS.explode({
        loanNo
    }))}`, {
        ...opts
    }));
}
/**
 * Update a calculation by calculation path and Receive a new calculation path on the updated calculation
 */
export function postCalculationByCalculationPathUpdate(calculationPath: string, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/${encodeURIComponent(calculationPath)}/update${QS.query(QS.explode({
        loanNo
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Add a manual compensation amount to an existing calculation given the calculation path. Receive a new calculation path on the updated calculation
 */
export function postCalculationAddmanualcompensationamountByCalculationPath(calculationPath: string, body?: number, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/addmanualcompensationamount/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        loanNo
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Fix the interest rate on existing calculation given the calculation path. Receive a new calculation path on the updated calculation
 */
export function postCalculationFixinterestrateByCalculationPath(calculationPath: string, body?: number, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 409;
        data: string;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/fixinterestrate/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        loanNo
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Create a new calculation in the storage account given a contractId for an existing loan in LAS. Receive the calculation path on the new created calculation
 */
export function postCreatecalculationByContractId(contractId: string, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/createcalculation/${encodeURIComponent(contractId)}${QS.query(QS.explode({
        loanNo
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Validate data in a calculation given by a calculation path. RequestId Valid values: 'IsInvalidForUpdate', 'IsInvalidForAgreement'. Note that if RequestId==IsInvalidForAgreement a allocationId must be provided or nothing will be validated
 */
export function postValidatecalculationsByRequestId(requestId: string, body?: string[], { allocationId, runDate }: {
    allocationId?: number;
    runDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ValidationResponse[];
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/validatecalculations/${encodeURIComponent(requestId)}${QS.query(QS.explode({
        allocationId,
        runDate
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Add a new event to an existing calculation given a calculation path. Receive a new calculation path on the updated calculation
 */
export function putAddcalculationeventConversion(conversionRequest?: ConversionRequest, { runDate }: {
    runDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/addcalculationevent/conversion${QS.query(QS.explode({
        runDate
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: conversionRequest
    })));
}
/**
 * Add a new credit to an existing calculation given a calculation path. Receive a new calculation path on the updated calculation
 */
export function putAddcalculationeventNewcreditByCalculationPath(calculationPath: string, newCreditRequest?: NewCreditRequest, { runDate, loanNo }: {
    runDate?: string;
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/addcalculationevent/newcredit/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        runDate,
        loanNo
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: newCreditRequest
    })));
}
/**
 * Add a new event to an existing calculation given a calculation path. Receive a new calculation path on the updated calculation
 */
export function putAddcalculationeventNewleasingByCalculationPath(calculationPath: string, newLeasingRequest?: NewLeasingRequest, { runDate, loanNo }: {
    runDate?: string;
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/addcalculationevent/newleasing/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        runDate,
        loanNo
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: newLeasingRequest
    })));
}
/**
 * Add a new event to an existing calculation given a calculation path. Receive a new calculation path on the updated calculation
 */
export function putAddcalculationeventNewloanByCalculationPath(calculationPath: string, body?: NewLoanRequest, { runDate, loanNo }: {
    runDate?: string;
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/addcalculationevent/newloan/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        runDate,
        loanNo
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    })));
}
/**
 * Create a renewed interest agreement calculation in the storage account given a contractId. Receive the calculation path on the new created calculation. Returns a conflict with an error message if the agreement is not supported for calculation.
 */
export function postCalculationRenewinterestagreementByContractId(contractId: string, { fixedInterestPeriodType, fixedInterestYears, loanNo, runDate }: {
    fixedInterestPeriodType?: string;
    fixedInterestYears?: number;
    loanNo?: number;
    runDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 409;
        data: string;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/renewinterestagreement/${encodeURIComponent(contractId)}${QS.query(QS.explode({
        fixedInterestPeriodType,
        fixedInterestYears,
        loanNo,
        runDate
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Create a list of renewed interest agreement calculations in the storage account given a contractId. Receive a list of calculation paths on the new created calculation. Returns a conflict with an error message if the agreement is not supported for calculation.
 */
export function postCalculationRenewinterestagreementmultiplefixingperiodsByContractId(contractId: string, multipleFixingPeriodsRequest?: MultipleFixingPeriodsRequest, { loanNo, runDate }: {
    loanNo?: number;
    runDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: MultipleFixingPeriodsResponse[];
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 409;
        data: string;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/calculation/renewinterestagreementmultiplefixingperiods/${encodeURIComponent(contractId)}${QS.query(QS.explode({
        loanNo,
        runDate
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: multipleFixingPeriodsRequest
    })));
}
/**
 * Add a new event to an existing calculation given a calculation path. Receive a new calculation path on the updated calculation
 */
export function putAddcalculationeventByCalculationPathExtrarepayment(calculationPath: string, partialRedemptionRequest?: PartialRedemptionRequest, { runDate, loanNo }: {
    runDate?: string;
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/addcalculationevent/${encodeURIComponent(calculationPath)}/extrarepayment${QS.query(QS.explode({
        runDate,
        loanNo
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: partialRedemptionRequest
    })));
}
/**
 * Add a new event to an existing calculation given a calculation path. Receive a new calculation path on the updated calculation
 */
export function putAddcalculationeventByCalculationPathFullredemption(calculationPath: string, fullRepaymentRequest?: FullRepaymentRequest, { runDate, loanNo }: {
    runDate?: string;
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/addcalculationevent/${encodeURIComponent(calculationPath)}/fullredemption${QS.query(QS.explode({
        runDate,
        loanNo
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: fullRepaymentRequest
    })));
}
/**
 * Create a new CalculationPath for new loan
 */
export function putCreatenewloancalculationpath({ contractId, loanNo }: {
    contractId?: string;
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/createnewloancalculationpath${QS.query(QS.explode({
        contractId,
        loanNo
    }))}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Create a new CalculationPath for StandAlone
 */
export function putCreatestandalonecalculationpath({ loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/createstandalonecalculationpath${QS.query(QS.explode({
        loanNo
    }))}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Save calculation parameters to LAS
 */
export function putSavecalculationparametersNewloanByCalculationPath(calculationPath: string, { loanNo }: {
    loanNo?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/savecalculationparameters/newloan/${encodeURIComponent(calculationPath)}${QS.query(QS.explode({
        loanNo
    }))}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Get loanparameters by calculationpath
 */
export function getLoanparametersByCalculationPath(calculationPath: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LoanParametersResponse;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/loanparameters/${encodeURIComponent(calculationPath)}`, {
        ...opts
    }));
}
/**
 * Move payout date for new contract in LAS
 */
export function putMovepayoutdateNewloanByContractId(contractId: string, { oldPayoutDate, newPayoutDate }: {
    oldPayoutDate?: string;
    newPayoutDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/movepayoutdate/newloan/${encodeURIComponent(contractId)}${QS.query(QS.explode({
        oldPayoutDate,
        newPayoutDate
    }))}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Move contract to deleted contracts in LAS
 */
export function putMarkcontractasdeletedNewloanByContractId(contractId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/markcontractasdeleted/newloan/${encodeURIComponent(contractId)}`, {
        ...opts,
        method: "PUT"
    }));
}
/**
 * Get a list of unpaid executed and signed loans
 */
export function getUnpaidsignedloans({ runDate }: {
    runDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string[];
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/unpaidsignedloans${QS.query(QS.explode({
        runDate
    }))}`, {
        ...opts
    }));
}
/**
 * Get a count of banking days to payout for loan
 */
export function getBankingdaycounttopayoutByContractId(contractId: string, { fromDate }: {
    fromDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/bankingdaycounttopayout/${encodeURIComponent(contractId)}${QS.query(QS.explode({
        fromDate
    }))}`, {
        ...opts
    }));
}
/**
 * Get guarantor liability informations for a contract
 */
export function getGuarantorliabilityByContractId(contractId: string, { fromDate }: {
    fromDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GuarantorLiabilityResponse[];
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/guarantorliability/${encodeURIComponent(contractId)}${QS.query(QS.explode({
        fromDate
    }))}`, {
        ...opts
    }));
}
/**
 * Check if contract exist in A360
 */
export function getIscontractina360ByContractId(contractId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/iscontractina360/${encodeURIComponent(contractId)}`, {
        ...opts
    }));
}
/**
 * Get a list of expiring contracts
 */
export function getExpiringagreements({ expiringFromDate, expiringToDate }: {
    expiringFromDate?: string;
    expiringToDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: ExpiringAgreementsResponse[];
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/expiringagreements${QS.query(QS.explode({
        expiringFromDate,
        expiringToDate
    }))}`, {
        ...opts
    }));
}
export function getLoanCalculationStateBackfillStatus(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LoanCalculationStateBackfillRun;
    }>("/loan-calculation-state-backfill/status", {
        ...opts
    }));
}
export function postLoanCalculationStateBackfill(body?: string[], { validateOnly, fromDate }: {
    validateOnly?: boolean;
    fromDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 202;
        data: LoanCalculationStateBackfillStartResult;
    } | {
        status: 409;
        data: LoanCalculationStateBackfillStartResult;
    }>(`/loan-calculation-state-backfill${QS.query(QS.explode({
        validateOnly,
        fromDate
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    })));
}
export function postLoanDaprSigncontractdraft(signingProcessCompleted?: SigningProcessCompleted, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/LoanDapr/signcontractdraft", oazapfts.json({
        ...opts,
        method: "POST",
        body: signingProcessCompleted
    })));
}
export function postLoanDaprScheduledaystopayout(contractDraftSigned?: ContractDraftSigned, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/LoanDapr/scheduledaystopayout", oazapfts.json({
        ...opts,
        method: "POST",
        body: contractDraftSigned
    })));
}
export function postLoanDaprDeactivatecontractdraft(caseClosed?: CaseClosed, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchText("/LoanDapr/deactivatecontractdraft", oazapfts.json({
        ...opts,
        method: "POST",
        body: caseClosed
    })));
}
/**
 * Get a list of Payment Notices for processing
 */
export function getPaymentnoticeGetpaymentnoticeforprocessing(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number[];
    }>("/paymentnotice/getpaymentnoticeforprocessing", {
        ...opts
    }));
}
/**
 * Retrieve the notices connected to the main notice in LAS
 */
export function getPaymentnoticeGetpaymentnotice({ notice }: {
    notice?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PaymentNoticeContract[];
    }>(`/paymentnotice/getpaymentnotice${QS.query(QS.explode({
        notice
    }))}`, {
        ...opts
    }));
}
/**
 * Update all notices with main notice id to handled
 */
export function postPaymentnoticePostupdatenotice({ mainNoticeId }: {
    mainNoticeId?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    }>(`/paymentnotice/postupdatenotice${QS.query(QS.explode({
        mainNoticeId
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Returns role information
 */
export function getRoles(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: {
            controller?: string;
            roles?: string;
            endpoint?: string;
            httpMethods?: string;
        };
    }>("/_roles", {
        ...opts
    }));
}
export enum ContractLoanTypeEnum {
    NurUdlan = "NUR_udl\u00E5n",
    UdlanModelB = "Udl\u00E5n_Model_B",
    KKvar = "KKvar",
    KKmax = "KKmax",
    KKbasis = "KKbasis",
    KKcibor = "KKcibor",
    KKcita = "KKcita",
    KKfast = "KKfast",
    K4Udlan = "K4_udl\u00E5n",
    AiKontant = "AI_kontant",
    Rentetilpasningslan = "Rentetilpasningsl\u00E5n",
    Indekslan = "Indeksl\u00E5n",
    Obligationslan = "Obligationsl\u00E5n",
    AiLan = "AI_l\u00E5n",
    Swap = "Swap",
    Renteswap = "Renteswap",
    Valutaswap = "Valutaswap",
    ValutaTermin = "ValutaTermin",
    ValutaSpot = "ValutaSpot",
    KontantlaanAiKontant = "Kontantlaan_AI_kontant",
    KontantlaanK4Udlan = "Kontantlaan_K4_udl\u00E5n",
    Byggekredit = "Byggekredit",
    UnDefined = "UnDefined",
    Kkkur = "KKKUR"
}
export enum PaymentAdviseTypes {
    Ean = "EAN",
    Bs = "BS",
    Pdf = "PDF"
}
export enum GuaranteeType {
    Guarantor = "Guarantor",
    StakeHolder = "StakeHolder"
}
export enum LoanEventStatus {
    Draft = "Draft",
    Approved = "Approved"
}
export enum ContractStatus {
    NotYetActive = "NotYetActive",
    Active = "Active",
    Archived = "Archived"
}
export enum AmortizationProfile {
    Bullet = "Bullet",
    Annuity = "Annuity",
    Serial = "Serial",
    Custom = "Custom",
    UnDefined = "UnDefined"
}
export enum PaymentFreqEnum {
    UnDefined = "UnDefined",
    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    M6 = "M6",
    M12 = "M12"
}
export enum InterestConvensionEnum {
    ThirtyThreeSixty = "ThirtyThreeSixty",
    ActAct = "ActAct",
    ActThreeSixty = "ActThreeSixty",
    ActThreeSixtyFive = "ActThreeSixtyFive",
    ThirtyThreeSixtyFive = "ThirtyThreeSixtyFive"
}
export enum SustainableFrameworkType {
    Gbf2017 = "GBF2017",
    Gbf2022 = "GBF2022",
    None = "None"
}
export enum CurrencyCode {
    Dkk = "DKK",
    Eur = "EUR",
    Gbp = "GBP",
    Usd = "USD",
    Chf = "CHF",
    Undefined = "Undefined"
}
export enum InterestRateStatus {
    Fixed = "Fixed",
    Estimated = "Estimated",
    BeforeInterestConditionExpiryDate = "BeforeInterestConditionExpiryDate",
    AfterInterestConditionExpiryDate = "AfterInterestConditionExpiryDate"
}
export enum AdjustedUnadjustedEnum {
    Adjusted = "Adjusted",
    Unadjusted = "Unadjusted"
}
export enum DayCountConventions {
    Normal30360 = "NORMAL_30_360",
    A365Fix = "A365Fix",
    Act360 = "Act_360",
    A365Isd = "A365ISD",
    ActAct = "Act_Act",
    Belgian365365 = "BELGIAN_365_365",
    Euro30360 = "EURO_30_360",
    Us30360 = "US_30_360",
    Isda30360 = "ISDA_30_360",
    UnDefined = "UnDefined"
}
export enum BusinessDayConventionEnum {
    Following = "Following",
    ModifiedFollowing = "ModifiedFollowing",
    Preceding = "Preceding"
}
export enum FixedInterestPeriodType {
    Cheapest = "Cheapest",
    ToMaturity = "ToMaturity",
    Years = "Years",
    UnDefined = "UnDefined"
}
export enum EventDescriptionCode {
    Conversion = "Conversion",
    FullRedemption = "FullRedemption",
    ExtraRepayment = "ExtraRepayment",
    NewLoan = "NewLoan",
    Redemption = "Redemption",
    NewInterestAgreement = "NewInterestAgreement"
}
export enum ChangeMethodCode {
    ReducedTimeToMaturity = "ReducedTimeToMaturity",
    ReducedPayment = "ReducedPayment",
    NewLoan = "NewLoan",
    RenewInterestAgreement = "RenewInterestAgreement"
}
export enum BudgetSecurity {
    Low = "Low",
    Medium = "Medium",
    High = "High",
    Undefined = "Undefined"
}
export enum LoanCategory {
    ContractLoan = "ContractLoan",
    ConstructionCredit = "ConstructionCredit",
    BondLoan = "BondLoan",
    SubsidizedLoan = "SubsidizedLoan",
    Swap = "Swap",
    Undefined = "Undefined"
}
export enum InterestType {
    Fixed = "Fixed",
    Floating = "Floating",
    Undefined = "Undefined"
}
export enum Relation {
    Owner = "Owner",
    Guarantee = "Guarantee",
    PartnershipLiability = "PartnershipLiability",
    BillReceiver = "BillReceiver",
    Undefined = "Undefined"
}
export enum LiabilityType {
    Undefined = "Undefined",
    ProRata = "ProRata",
    Solidarity = "Solidarity"
}
export enum ModificationStateEnum {
    Original = "Original",
    New = "New",
    Update = "Update",
    Delete = "Delete"
}
export enum InterestDetailedPaymentType {
    ClearCompensation = "ClearCompensation",
    Repayment = "Repayment",
    ExtraordinaryRepayment = "ExtraordinaryRepayment",
    Margin = "Margin",
    AccruedMargin = "AccruedMargin",
    Principal = "Principal",
    AppreciationInterestAndMargin = "AppreciationInterestAndMargin",
    AdditionalChargeAndRebateMargin = "AdditionalChargeAndRebateMargin",
    CashLoanInterest = "CashLoanInterest",
    InterestAdjustmentsKkmax = "InterestAdjustmentsKKMAX",
    Interest = "Interest",
    AccruedInterest = "AccruedInterest",
    TechnicalRepayment = "TechnicalRepayment",
    TechnicalPrincipal = "TechnicalPrincipal",
    AppreciationInterest = "AppreciationInterest",
    AppreciationMargin = "AppreciationMargin",
    AccruedAdditionalChargeAndRebateMargin = "AccruedAdditionalChargeAndRebateMargin",
    Undecided = "Undecided"
}
export enum AdditionalPaymentTypeEnum {
    AddRabatFastrentelan = "Add_Rabat_fastrentel\u00E5n",
    AdditionalPayment = "Additional_payment",
    GodgorelseRenteberegning = "Godg\u00F8relse_renteberegning",
    IndfriKompensation = "Indfri_kompensation",
    IndfriRente = "Indfri_rente",
    KursAftalelan = "Kurs_aftalel\u00E5n",
    UnDefined = "UnDefined"
}
export enum LoanDateStatus {
    Found = "Found",
    NoPayoutDate = "NoPayoutDate",
    ContractNotFound = "ContractNotFound",
    MissingRequiredData = "MissingRequiredData"
}
export enum ExecutionStatusEnum {
    NotStarted = "NotStarted",
    Ok = "OK",
    Error = "Error",
    Running = "Running",
    NotRelevant = "NotRelevant",
    Undefined = "Undefined"
}
export enum CurveEnum {
    DkkDkkswap = "DKK_DKKSWAP",
    IndfriKkvar3M = "INDFRI_KKVAR3M",
    IndfriKkvar6M = "INDFRI_KKVAR6M",
    IndfriKkvar1Y = "INDFRI_KKVAR1Y",
    Kkvar3M = "KKVAR3M",
    Kkvar6M = "KKVAR6M",
    Kkvar1Y = "KKVAR1Y",
    IndfriKkcibMax5Y = "INDFRI_KKCIB_MAX5Y",
    IndfriKkcibMin6Y = "INDFRI_KKCIB_MIN6Y",
    KkciborMax5YPris = "KKCIBOR_MAX5Y_PRIS",
    KkciborMin6YPris = "KKCIBOR_MIN6Y_PRIS",
    KkfastMax5YPris = "KKFAST_MAX5Y_PRIS",
    KkfastMin6YPris = "KKFAST_MIN6Y_PRIS",
    IndfriKkfastMax5Y = "INDFRI_KKFAST_MAX5Y",
    IndfriKkfastMin6Y = "INDFRI_KKFAST_MIN6Y",
    Tdkk3M6M = "TDKK3M6M",
    Tdkk6M12M = "TDKK6M12M",
    Tdkk1Y6M = "TDKK1Y6M",
    Kkbasis1M = "KKBASIS1M",
    Kkbasis3M = "KKBASIS3M",
    Kkbasis6M = "KKBASIS6M",
    Kkbasis1Y = "KKBASIS1Y",
    FundingspreadPremium = "FUNDINGSPREAD_PREMIUM",
    NotInUse = "NotInUse",
    DkkLaaneask = "DKK_LAANEASK",
    L3M6Mbid = "L3M6MBID",
    DkkLaanemidCash = "DKK_LAANEMID_Cash",
    Zero = "Zero",
    DkkCibor = "DKK_CIBOR",
    Kkvar1M = "KKVAR1M"
}
export enum PricingRuleEnum {
    Inkvar3M = "INKVAR3M",
    Inkvar6M = "INKVAR6M",
    Inkvar1Y = "INKVAR1Y",
    Kkvar3M = "KKVAR3M",
    Kkvar6M = "KKVAR6M",
    Incibu5Y3M = "INCIBU5Y3M",
    Incibo6Y3M = "INCIBO6Y3M",
    Kkcibu5Y3M = "KKCIBU5Y3M",
    Kkcibo6Y3M = "KKCIBO6Y3M",
    Incibu5Y6M = "INCIBU5Y6M",
    Incibo6Y6M = "INCIBO6Y6M",
    Kkcibu5Y6M = "KKCIBU5Y6M",
    Kkcibo6Y6M = "KKCIBO6Y6M",
    Incibu5Y1Y = "INCIBU5Y1Y",
    Incibo6Y1Y = "INCIBO6Y1Y",
    Kkfasu5Y = "KKFASU5Y",
    Kkfaso6Y = "KKFASO6Y",
    Infasu5Y = "INFASU5Y",
    Infaso6Y = "INFASO6Y",
    Kkbasis1M = "KKBASIS1M",
    Kkbasis3M = "KKBASIS3M",
    Kkbasis6M = "KKBASIS6M",
    Kkbasis1Y = "KKBASIS1Y",
    Ikkmax = "IKKMAX",
    OnlySwap = "OnlySwap",
    UnDefined = "UnDefined",
    InkvarOutsideFixedPeriods3M = "INKVAROutsideFixedPeriods3M",
    InkvarOutsideFixedPeriods6M = "INKVAROutsideFixedPeriods6M",
    Kkbasis1MOutsideFixing = "KKBASIS1MOutsideFixing",
    Kkbasis3MOutsideFixing = "KKBASIS3MOutsideFixing",
    Kkbasis6MOutsideFixing = "KKBASIS6MOutsideFixing",
    Kkbasis1YOutsideFixing = "KKBASIS1YOutsideFixing"
}
export enum LoanValidationEnum {
    InvalidDate = "InvalidDate",
    PaymentTooHigh = "PaymentTooHigh",
    InvalidLas = "InvalidLAS",
    InvalidStartDate = "InvalidStartDate",
    InvalidPrincipalAmount = "InvalidPrincipalAmount",
    InvalidTimeToMaturity = "InvalidTimeToMaturity",
    InvalidLoanProduct = "InvalidLoanProduct",
    PaymentInfoNotValid = "PaymentInfoNotValid",
    ReenterPowerOfAttorneyHolders = "ReenterPowerOfAttorneyHolders",
    CustomerNotApprovedInCrm = "CustomerNotApprovedInCrm",
    AllocationNotApproved = "AllocationNotApproved",
    CaseInfoStatesNotComplete = "CaseInfoStatesNotComplete",
    CalculationTimeExceeded = "CalculationTimeExceeded",
    CalculationFailed = "CalculationFailed",
    ContactNotFoundInCrm = "ContactNotFoundInCRM",
    ContactInactiveInCrm = "ContactInactiveInCRM",
    FirstInterestDateExceeded = "FirstInterestDateExceeded",
    CanOnlyForceNewInterestAgreement = "CanOnlyForceNewInterestAgreement"
}
export enum MarginCalculationMethod {
    MarginCalculatedByRemainingDebt = "MarginCalculatedByRemainingDebt",
    MarginCalculatedByPrincipal = "MarginCalculatedByPrincipal"
}
export enum GuaranteeRelations {
    GuarantorAlone = "GuarantorAlone",
    GuarantorProRata = "GuarantorProRata",
    StakeHolderGuaranteeProRata = "StakeHolderGuaranteeProRata",
    GuarantorInSolidarity = "GuarantorInSolidarity",
    StakeHolderGuarantee = "StakeHolderGuarantee"
}
export enum LoanCalculationStateBackfillRunState {
    NotStarted = "NotStarted",
    Queued = "Queued",
    Running = "Running",
    Completed = "Completed",
    CompletedWithFailures = "CompletedWithFailures",
    Failed = "Failed",
    Interrupted = "Interrupted"
}

// #region INJECTED PATHS
/* The generated output is not a direct result of oazapfts' default behavior.
* It instead incorporates our custom code, which adds path placeholder properties for MSW mocking, into the output of oazapfts. */
// {{{

const _getAllocationGetallocationByAllocationIdPath = () => defaults.baseUrl + '/allocation/getallocation/:allocationId';
Object.defineProperty(getAllocationGetallocationByAllocationId, 'path', { get: _getAllocationGetallocationByAllocationIdPath, set: _getAllocationGetallocationByAllocationIdPath });
/** @path `/allocation/getallocation/:allocationId` */ 
getAllocationGetallocationByAllocationId.path = getAllocationGetallocationByAllocationId.path satisfies string;


const _getAllocationGetallocationbycompanyidByCompanyIdPath = () => defaults.baseUrl + '/allocation/getallocationbycompanyid/:companyId';
Object.defineProperty(getAllocationGetallocationbycompanyidByCompanyId, 'path', { get: _getAllocationGetallocationbycompanyidByCompanyIdPath, set: _getAllocationGetallocationbycompanyidByCompanyIdPath });
/** @path `/allocation/getallocationbycompanyid/:companyId` */ 
getAllocationGetallocationbycompanyidByCompanyId.path = getAllocationGetallocationbycompanyidByCompanyId.path satisfies string;


const _postAllocationNewallocationPath = () => defaults.baseUrl + '/allocation/newallocation';
Object.defineProperty(postAllocationNewallocation, 'path', { get: _postAllocationNewallocationPath, set: _postAllocationNewallocationPath });
/** @path `/allocation/newallocation` */ 
postAllocationNewallocation.path = postAllocationNewallocation.path satisfies string;


const _putAllocationUpdateallocationByAllocationIdPath = () => defaults.baseUrl + '/allocation/updateallocation/:allocationId';
Object.defineProperty(putAllocationUpdateallocationByAllocationId, 'path', { get: _putAllocationUpdateallocationByAllocationIdPath, set: _putAllocationUpdateallocationByAllocationIdPath });
/** @path `/allocation/updateallocation/:allocationId` */ 
putAllocationUpdateallocationByAllocationId.path = putAllocationUpdateallocationByAllocationId.path satisfies string;


const _postAllocationNewcontractDraftPath = () => defaults.baseUrl + '/allocation/newcontractDraft';
Object.defineProperty(postAllocationNewcontractDraft, 'path', { get: _postAllocationNewcontractDraftPath, set: _postAllocationNewcontractDraftPath });
/** @path `/allocation/newcontractDraft` */ 
postAllocationNewcontractDraft.path = postAllocationNewcontractDraft.path satisfies string;


const _putAllocationUpdatecontractDraftByContractDraftIdPath = () => defaults.baseUrl + '/allocation/updatecontractDraft/:contractDraftId';
Object.defineProperty(putAllocationUpdatecontractDraftByContractDraftId, 'path', { get: _putAllocationUpdatecontractDraftByContractDraftIdPath, set: _putAllocationUpdatecontractDraftByContractDraftIdPath });
/** @path `/allocation/updatecontractDraft/:contractDraftId` */ 
putAllocationUpdatecontractDraftByContractDraftId.path = putAllocationUpdatecontractDraftByContractDraftId.path satisfies string;


const _getAllocationGetcontractDraftByContractDraftIdPath = () => defaults.baseUrl + '/allocation/getcontractDraft/:contractDraftId';
Object.defineProperty(getAllocationGetcontractDraftByContractDraftId, 'path', { get: _getAllocationGetcontractDraftByContractDraftIdPath, set: _getAllocationGetcontractDraftByContractDraftIdPath });
/** @path `/allocation/getcontractDraft/:contractDraftId` */ 
getAllocationGetcontractDraftByContractDraftId.path = getAllocationGetcontractDraftByContractDraftId.path satisfies string;


const _getAllocationGetcontractdraftrelationsByContractDraftIdPath = () => defaults.baseUrl + '/allocation/getcontractdraftrelations/:contractDraftId';
Object.defineProperty(getAllocationGetcontractdraftrelationsByContractDraftId, 'path', { get: _getAllocationGetcontractdraftrelationsByContractDraftIdPath, set: _getAllocationGetcontractdraftrelationsByContractDraftIdPath });
/** @path `/allocation/getcontractdraftrelations/:contractDraftId` */ 
getAllocationGetcontractdraftrelationsByContractDraftId.path = getAllocationGetcontractdraftrelationsByContractDraftId.path satisfies string;


const _getAllocationGetcompanyguarantorsByCompanyIdPath = () => defaults.baseUrl + '/allocation/getcompanyguarantors/:companyId';
Object.defineProperty(getAllocationGetcompanyguarantorsByCompanyId, 'path', { get: _getAllocationGetcompanyguarantorsByCompanyIdPath, set: _getAllocationGetcompanyguarantorsByCompanyIdPath });
/** @path `/allocation/getcompanyguarantors/:companyId` */ 
getAllocationGetcompanyguarantorsByCompanyId.path = getAllocationGetcompanyguarantorsByCompanyId.path satisfies string;


const _putAllocationUpdateguaranteerelationsforcontractdraftByContractDraftIdPath = () => defaults.baseUrl + '/allocation/updateguaranteerelationsforcontractdraft/:contractDraftId';
Object.defineProperty(putAllocationUpdateguaranteerelationsforcontractdraftByContractDraftId, 'path', { get: _putAllocationUpdateguaranteerelationsforcontractdraftByContractDraftIdPath, set: _putAllocationUpdateguaranteerelationsforcontractdraftByContractDraftIdPath });
/** @path `/allocation/updateguaranteerelationsforcontractdraft/:contractDraftId` */ 
putAllocationUpdateguaranteerelationsforcontractdraftByContractDraftId.path = putAllocationUpdateguaranteerelationsforcontractdraftByContractDraftId.path satisfies string;


const _getAllocationGetCompanyEanByCompanyIdPath = () => defaults.baseUrl + '/allocation/getCompanyEAN/:companyId';
Object.defineProperty(getAllocationGetCompanyEanByCompanyId, 'path', { get: _getAllocationGetCompanyEanByCompanyIdPath, set: _getAllocationGetCompanyEanByCompanyIdPath });
/** @path `/allocation/getCompanyEAN/:companyId` */ 
getAllocationGetCompanyEanByCompanyId.path = getAllocationGetCompanyEanByCompanyId.path satisfies string;


const _putAllocationUpdatecontractdraftpaymentadviseinformationsByContractDraftIdPath = () => defaults.baseUrl + '/allocation/updatecontractdraftpaymentadviseinformations/:contractDraftId';
Object.defineProperty(putAllocationUpdatecontractdraftpaymentadviseinformationsByContractDraftId, 'path', { get: _putAllocationUpdatecontractdraftpaymentadviseinformationsByContractDraftIdPath, set: _putAllocationUpdatecontractdraftpaymentadviseinformationsByContractDraftIdPath });
/** @path `/allocation/updatecontractdraftpaymentadviseinformations/:contractDraftId` */ 
putAllocationUpdatecontractdraftpaymentadviseinformationsByContractDraftId.path = putAllocationUpdatecontractdraftpaymentadviseinformationsByContractDraftId.path satisfies string;


const _putAllocationUpdatecontractdraftindustrycodeinformationByContractDraftIdPath = () => defaults.baseUrl + '/allocation/updatecontractdraftindustrycodeinformation/:contractDraftId';
Object.defineProperty(putAllocationUpdatecontractdraftindustrycodeinformationByContractDraftId, 'path', { get: _putAllocationUpdatecontractdraftindustrycodeinformationByContractDraftIdPath, set: _putAllocationUpdatecontractdraftindustrycodeinformationByContractDraftIdPath });
/** @path `/allocation/updatecontractdraftindustrycodeinformation/:contractDraftId` */ 
putAllocationUpdatecontractdraftindustrycodeinformationByContractDraftId.path = putAllocationUpdatecontractdraftindustrycodeinformationByContractDraftId.path satisfies string;


const _putAllocationUpdatecontractdraftguaranteerequirementByContractDraftIdPath = () => defaults.baseUrl + '/allocation/updatecontractdraftguaranteerequirement/:contractDraftId';
Object.defineProperty(putAllocationUpdatecontractdraftguaranteerequirementByContractDraftId, 'path', { get: _putAllocationUpdatecontractdraftguaranteerequirementByContractDraftIdPath, set: _putAllocationUpdatecontractdraftguaranteerequirementByContractDraftIdPath });
/** @path `/allocation/updatecontractdraftguaranteerequirement/:contractDraftId` */ 
putAllocationUpdatecontractdraftguaranteerequirementByContractDraftId.path = putAllocationUpdatecontractdraftguaranteerequirementByContractDraftId.path satisfies string;


const _putAllocationDeactivatecontractdraftByContractDraftIdPath = () => defaults.baseUrl + '/allocation/deactivatecontractdraft/:contractDraftId';
Object.defineProperty(putAllocationDeactivatecontractdraftByContractDraftId, 'path', { get: _putAllocationDeactivatecontractdraftByContractDraftIdPath, set: _putAllocationDeactivatecontractdraftByContractDraftIdPath });
/** @path `/allocation/deactivatecontractdraft/:contractDraftId` */ 
putAllocationDeactivatecontractdraftByContractDraftId.path = putAllocationDeactivatecontractdraftByContractDraftId.path satisfies string;


const _putAllocationDeactivateallocationByAllocationIdPath = () => defaults.baseUrl + '/allocation/deactivateallocation/:allocationId';
Object.defineProperty(putAllocationDeactivateallocationByAllocationId, 'path', { get: _putAllocationDeactivateallocationByAllocationIdPath, set: _putAllocationDeactivateallocationByAllocationIdPath });
/** @path `/allocation/deactivateallocation/:allocationId` */ 
putAllocationDeactivateallocationByAllocationId.path = putAllocationDeactivateallocationByAllocationId.path satisfies string;


const _putAllocationSigncontractdraftByContractDraftIdPath = () => defaults.baseUrl + '/allocation/signcontractdraft/:contractDraftId';
Object.defineProperty(putAllocationSigncontractdraftByContractDraftId, 'path', { get: _putAllocationSigncontractdraftByContractDraftIdPath, set: _putAllocationSigncontractdraftByContractDraftIdPath });
/** @path `/allocation/signcontractdraft/:contractDraftId` */ 
putAllocationSigncontractdraftByContractDraftId.path = putAllocationSigncontractdraftByContractDraftId.path satisfies string;


const _postConversiondraftNewconversiondraftPath = () => defaults.baseUrl + '/conversiondraft/newconversiondraft';
Object.defineProperty(postConversiondraftNewconversiondraft, 'path', { get: _postConversiondraftNewconversiondraftPath, set: _postConversiondraftNewconversiondraftPath });
/** @path `/conversiondraft/newconversiondraft` */ 
postConversiondraftNewconversiondraft.path = postConversiondraftNewconversiondraft.path satisfies string;


const _putConversiondraftUpdateconversiondraftByLoanEventIdPath = () => defaults.baseUrl + '/conversiondraft/updateconversiondraft/:loanEventId';
Object.defineProperty(putConversiondraftUpdateconversiondraftByLoanEventId, 'path', { get: _putConversiondraftUpdateconversiondraftByLoanEventIdPath, set: _putConversiondraftUpdateconversiondraftByLoanEventIdPath });
/** @path `/conversiondraft/updateconversiondraft/:loanEventId` */ 
putConversiondraftUpdateconversiondraftByLoanEventId.path = putConversiondraftUpdateconversiondraftByLoanEventId.path satisfies string;


const _getConversiondraftGetconversiondraftByLoanEventIdPath = () => defaults.baseUrl + '/conversiondraft/getconversiondraft/:loanEventId';
Object.defineProperty(getConversiondraftGetconversiondraftByLoanEventId, 'path', { get: _getConversiondraftGetconversiondraftByLoanEventIdPath, set: _getConversiondraftGetconversiondraftByLoanEventIdPath });
/** @path `/conversiondraft/getconversiondraft/:loanEventId` */ 
getConversiondraftGetconversiondraftByLoanEventId.path = getConversiondraftGetconversiondraftByLoanEventId.path satisfies string;


const _deleteConversiondraftDeleteconversiondraftByLoanEventIdPath = () => defaults.baseUrl + '/conversiondraft/deleteconversiondraft/:loanEventId';
Object.defineProperty(deleteConversiondraftDeleteconversiondraftByLoanEventId, 'path', { get: _deleteConversiondraftDeleteconversiondraftByLoanEventIdPath, set: _deleteConversiondraftDeleteconversiondraftByLoanEventIdPath });
/** @path `/conversiondraft/deleteconversiondraft/:loanEventId` */ 
deleteConversiondraftDeleteconversiondraftByLoanEventId.path = deleteConversiondraftDeleteconversiondraftByLoanEventId.path satisfies string;


const _postConversiondraftCreateconversionfromconversiondraftByLoanEventIdPath = () => defaults.baseUrl + '/conversiondraft/createconversionfromconversiondraft/:loanEventId';
Object.defineProperty(postConversiondraftCreateconversionfromconversiondraftByLoanEventId, 'path', { get: _postConversiondraftCreateconversionfromconversiondraftByLoanEventIdPath, set: _postConversiondraftCreateconversionfromconversiondraftByLoanEventIdPath });
/** @path `/conversiondraft/createconversionfromconversiondraft/:loanEventId` */ 
postConversiondraftCreateconversionfromconversiondraftByLoanEventId.path = postConversiondraftCreateconversionfromconversiondraftByLoanEventId.path satisfies string;


const _getSearchloansPath = () => defaults.baseUrl + '/searchloans';
Object.defineProperty(getSearchloans, 'path', { get: _getSearchloansPath, set: _getSearchloansPath });
/** @path `/searchloans` */ 
getSearchloans.path = getSearchloans.path satisfies string;


const _getSearchloanrelationsPath = () => defaults.baseUrl + '/searchloanrelations';
Object.defineProperty(getSearchloanrelations, 'path', { get: _getSearchloanrelationsPath, set: _getSearchloanrelationsPath });
/** @path `/searchloanrelations` */ 
getSearchloanrelations.path = getSearchloanrelations.path satisfies string;


const _getCalculationByCalculationPathHolidaysAndHolidayUsagePath = () => defaults.baseUrl + '/calculation/:calculationPath/holidays/:holidayUsage';
Object.defineProperty(getCalculationByCalculationPathHolidaysAndHolidayUsage, 'path', { get: _getCalculationByCalculationPathHolidaysAndHolidayUsagePath, set: _getCalculationByCalculationPathHolidaysAndHolidayUsagePath });
/** @path `/calculation/:calculationPath/holidays/:holidayUsage` */ 
getCalculationByCalculationPathHolidaysAndHolidayUsage.path = getCalculationByCalculationPathHolidaysAndHolidayUsage.path satisfies string;


const _getCalculationByContractIdPayoutholidaysAndHolidayUsagePath = () => defaults.baseUrl + '/calculation/:contractId/payoutholidays/:holidayUsage';
Object.defineProperty(getCalculationByContractIdPayoutholidaysAndHolidayUsage, 'path', { get: _getCalculationByContractIdPayoutholidaysAndHolidayUsagePath, set: _getCalculationByContractIdPayoutholidaysAndHolidayUsagePath });
/** @path `/calculation/:contractId/payoutholidays/:holidayUsage` */ 
getCalculationByContractIdPayoutholidaysAndHolidayUsage.path = getCalculationByContractIdPayoutholidaysAndHolidayUsage.path satisfies string;


const _getCalculationInterestsheetPath = () => defaults.baseUrl + '/calculation/interestsheet';
Object.defineProperty(getCalculationInterestsheet, 'path', { get: _getCalculationInterestsheetPath, set: _getCalculationInterestsheetPath });
/** @path `/calculation/interestsheet` */ 
getCalculationInterestsheet.path = getCalculationInterestsheet.path satisfies string;


const _getCalculationBudgetPath = () => defaults.baseUrl + '/calculation/budget';
Object.defineProperty(getCalculationBudget, 'path', { get: _getCalculationBudgetPath, set: _getCalculationBudgetPath });
/** @path `/calculation/budget` */ 
getCalculationBudget.path = getCalculationBudget.path satisfies string;


const _getCalculationFetchstandardcalculationfromstoragePath = () => defaults.baseUrl + '/calculation/fetchstandardcalculationfromstorage';
Object.defineProperty(getCalculationFetchstandardcalculationfromstorage, 'path', { get: _getCalculationFetchstandardcalculationfromstoragePath, set: _getCalculationFetchstandardcalculationfromstoragePath });
/** @path `/calculation/fetchstandardcalculationfromstorage` */ 
getCalculationFetchstandardcalculationfromstorage.path = getCalculationFetchstandardcalculationfromstorage.path satisfies string;


const _getCalculationLeasinginterestsPath = () => defaults.baseUrl + '/calculation/leasinginterests';
Object.defineProperty(getCalculationLeasinginterests, 'path', { get: _getCalculationLeasinginterestsPath, set: _getCalculationLeasinginterestsPath });
/** @path `/calculation/leasinginterests` */ 
getCalculationLeasinginterests.path = getCalculationLeasinginterests.path satisfies string;


const _getCalculationPricesheetPath = () => defaults.baseUrl + '/calculation/pricesheet';
Object.defineProperty(getCalculationPricesheet, 'path', { get: _getCalculationPricesheetPath, set: _getCalculationPricesheetPath });
/** @path `/calculation/pricesheet` */ 
getCalculationPricesheet.path = getCalculationPricesheet.path satisfies string;


const _getContractsWithexpiringinterestagreementPath = () => defaults.baseUrl + '/contracts/withexpiringinterestagreement';
Object.defineProperty(getContractsWithexpiringinterestagreement, 'path', { get: _getContractsWithexpiringinterestagreementPath, set: _getContractsWithexpiringinterestagreementPath });
/** @path `/contracts/withexpiringinterestagreement` */ 
getContractsWithexpiringinterestagreement.path = getContractsWithexpiringinterestagreement.path satisfies string;


const _getCustomerByCompanyIdEodloanportfolioPath = () => defaults.baseUrl + '/customer/:companyId/eodloanportfolio';
Object.defineProperty(getCustomerByCompanyIdEodloanportfolio, 'path', { get: _getCustomerByCompanyIdEodloanportfolioPath, set: _getCustomerByCompanyIdEodloanportfolioPath });
/** @path `/customer/:companyId/eodloanportfolio` */ 
getCustomerByCompanyIdEodloanportfolio.path = getCustomerByCompanyIdEodloanportfolio.path satisfies string;


const _getCustomerByCompanyIdEodaggregatedportfolioPath = () => defaults.baseUrl + '/customer/:companyId/eodaggregatedportfolio';
Object.defineProperty(getCustomerByCompanyIdEodaggregatedportfolio, 'path', { get: _getCustomerByCompanyIdEodaggregatedportfolioPath, set: _getCustomerByCompanyIdEodaggregatedportfolioPath });
/** @path `/customer/:companyId/eodaggregatedportfolio` */ 
getCustomerByCompanyIdEodaggregatedportfolio.path = getCustomerByCompanyIdEodaggregatedportfolio.path satisfies string;


const _getCustomerEarliestvalidfilterdatePath = () => defaults.baseUrl + '/customer/earliestvalidfilterdate';
Object.defineProperty(getCustomerEarliestvalidfilterdate, 'path', { get: _getCustomerEarliestvalidfilterdatePath, set: _getCustomerEarliestvalidfilterdatePath });
/** @path `/customer/earliestvalidfilterdate` */ 
getCustomerEarliestvalidfilterdate.path = getCustomerEarliestvalidfilterdate.path satisfies string;


const _getEligibleloansByCompanyIdPath = () => defaults.baseUrl + '/eligibleloans/:companyId';
Object.defineProperty(getEligibleloansByCompanyId, 'path', { get: _getEligibleloansByCompanyIdPath, set: _getEligibleloansByCompanyIdPath });
/** @path `/eligibleloans/:companyId` */ 
getEligibleloansByCompanyId.path = getEligibleloansByCompanyId.path satisfies string;


const _getExecutecalculationByCalculationPathPath = () => defaults.baseUrl + '/executecalculation/:calculationPath';
Object.defineProperty(getExecutecalculationByCalculationPath, 'path', { get: _getExecutecalculationByCalculationPathPath, set: _getExecutecalculationByCalculationPathPath });
/** @path `/executecalculation/:calculationPath` */ 
getExecutecalculationByCalculationPath.path = getExecutecalculationByCalculationPath.path satisfies string;


const _postExecutecalculationByCalculationPathPath = () => defaults.baseUrl + '/executecalculation/:calculationPath';
Object.defineProperty(postExecutecalculationByCalculationPath, 'path', { get: _postExecutecalculationByCalculationPathPath, set: _postExecutecalculationByCalculationPathPath });
/** @path `/executecalculation/:calculationPath` */ 
postExecutecalculationByCalculationPath.path = postExecutecalculationByCalculationPath.path satisfies string;


const _getFetchcalculationfromstorageByCalculationPathPath = () => defaults.baseUrl + '/fetchcalculationfromstorage/:calculationPath';
Object.defineProperty(getFetchcalculationfromstorageByCalculationPath, 'path', { get: _getFetchcalculationfromstorageByCalculationPathPath, set: _getFetchcalculationfromstorageByCalculationPathPath });
/** @path `/fetchcalculationfromstorage/:calculationPath` */ 
getFetchcalculationfromstorageByCalculationPath.path = getFetchcalculationfromstorageByCalculationPath.path satisfies string;


const _getFetchcreditcalculationfromstorageByCalculationPathPath = () => defaults.baseUrl + '/fetchcreditcalculationfromstorage/:calculationPath';
Object.defineProperty(getFetchcreditcalculationfromstorageByCalculationPath, 'path', { get: _getFetchcreditcalculationfromstorageByCalculationPathPath, set: _getFetchcreditcalculationfromstorageByCalculationPathPath });
/** @path `/fetchcreditcalculationfromstorage/:calculationPath` */ 
getFetchcreditcalculationfromstorageByCalculationPath.path = getFetchcreditcalculationfromstorageByCalculationPath.path satisfies string;


const _postCalculationCreditrecalculatePath = () => defaults.baseUrl + '/calculation/creditrecalculate';
Object.defineProperty(postCalculationCreditrecalculate, 'path', { get: _postCalculationCreditrecalculatePath, set: _postCalculationCreditrecalculatePath });
/** @path `/calculation/creditrecalculate` */ 
postCalculationCreditrecalculate.path = postCalculationCreditrecalculate.path satisfies string;


const _postCalculationCreditrecalculateBatchPath = () => defaults.baseUrl + '/calculation/creditrecalculate/batch';
Object.defineProperty(postCalculationCreditrecalculateBatch, 'path', { get: _postCalculationCreditrecalculateBatchPath, set: _postCalculationCreditrecalculateBatchPath });
/** @path `/calculation/creditrecalculate/batch` */ 
postCalculationCreditrecalculateBatch.path = postCalculationCreditrecalculateBatch.path satisfies string;


const _postContractsRedemptionmarketvaluesPath = () => defaults.baseUrl + '/contracts/redemptionmarketvalues';
Object.defineProperty(postContractsRedemptionmarketvalues, 'path', { get: _postContractsRedemptionmarketvaluesPath, set: _postContractsRedemptionmarketvaluesPath });
/** @path `/contracts/redemptionmarketvalues` */ 
postContractsRedemptionmarketvalues.path = postContractsRedemptionmarketvalues.path satisfies string;


const _getFetchfilefromstorageByCalculationPathPath = () => defaults.baseUrl + '/fetchfilefromstorage/:calculationPath';
Object.defineProperty(getFetchfilefromstorageByCalculationPath, 'path', { get: _getFetchfilefromstorageByCalculationPathPath, set: _getFetchfilefromstorageByCalculationPathPath });
/** @path `/fetchfilefromstorage/:calculationPath` */ 
getFetchfilefromstorageByCalculationPath.path = getFetchfilefromstorageByCalculationPath.path satisfies string;


const _getGetloancalculationdetailsascsvByCalculationPathPath = () => defaults.baseUrl + '/getloancalculationdetailsascsv/:calculationPath';
Object.defineProperty(getGetloancalculationdetailsascsvByCalculationPath, 'path', { get: _getGetloancalculationdetailsascsvByCalculationPathPath, set: _getGetloancalculationdetailsascsvByCalculationPathPath });
/** @path `/getloancalculationdetailsascsv/:calculationPath` */ 
getGetloancalculationdetailsascsvByCalculationPath.path = getGetloancalculationdetailsascsvByCalculationPath.path satisfies string;


const _getFirstinterestpaymentdateByStartDatePath = () => defaults.baseUrl + '/firstinterestpaymentdate/:startDate';
Object.defineProperty(getFirstinterestpaymentdateByStartDate, 'path', { get: _getFirstinterestpaymentdateByStartDatePath, set: _getFirstinterestpaymentdateByStartDatePath });
/** @path `/firstinterestpaymentdate/:startDate` */ 
getFirstinterestpaymentdateByStartDate.path = getFirstinterestpaymentdateByStartDate.path satisfies string;


const _getGetcreditinfoByContractIdPath = () => defaults.baseUrl + '/getcreditinfo/:contractId';
Object.defineProperty(getGetcreditinfoByContractId, 'path', { get: _getGetcreditinfoByContractIdPath, set: _getGetcreditinfoByContractIdPath });
/** @path `/getcreditinfo/:contractId` */ 
getGetcreditinfoByContractId.path = getGetcreditinfoByContractId.path satisfies string;


const _loanDatesPath = () => defaults.baseUrl + '/loan-dates';
Object.defineProperty(loanDates, 'path', { get: _loanDatesPath, set: _loanDatesPath });
/** @path `/loan-dates` */ 
loanDates.path = loanDates.path satisfies string;


const _getLoaninfoByContractIdPath = () => defaults.baseUrl + '/loaninfo/:contractId';
Object.defineProperty(getLoaninfoByContractId, 'path', { get: _getLoaninfoByContractIdPath, set: _getLoaninfoByContractIdPath });
/** @path `/loaninfo/:contractId` */ 
getLoaninfoByContractId.path = getLoaninfoByContractId.path satisfies string;


const _getPartialredemptiondateByCalculationPathPath = () => defaults.baseUrl + '/partialredemptiondate/:calculationPath';
Object.defineProperty(getPartialredemptiondateByCalculationPath, 'path', { get: _getPartialredemptiondateByCalculationPathPath, set: _getPartialredemptiondateByCalculationPathPath });
/** @path `/partialredemptiondate/:calculationPath` */ 
getPartialredemptiondateByCalculationPath.path = getPartialredemptiondateByCalculationPath.path satisfies string;


const _getStatusexecutecalculationByCalculationPathPath = () => defaults.baseUrl + '/statusexecutecalculation/:calculationPath';
Object.defineProperty(getStatusexecutecalculationByCalculationPath, 'path', { get: _getStatusexecutecalculationByCalculationPathPath, set: _getStatusexecutecalculationByCalculationPathPath });
/** @path `/statusexecutecalculation/:calculationPath` */ 
getStatusexecutecalculationByCalculationPath.path = getStatusexecutecalculationByCalculationPath.path satisfies string;


const _getCalculationByCalculationPathGetcalculationdetailsPath = () => defaults.baseUrl + '/calculation/:calculationPath/getcalculationdetails';
Object.defineProperty(getCalculationByCalculationPathGetcalculationdetails, 'path', { get: _getCalculationByCalculationPathGetcalculationdetailsPath, set: _getCalculationByCalculationPathGetcalculationdetailsPath });
/** @path `/calculation/:calculationPath/getcalculationdetails` */ 
getCalculationByCalculationPathGetcalculationdetails.path = getCalculationByCalculationPathGetcalculationdetails.path satisfies string;


const _postCalculationByCalculationPathUpdatePath = () => defaults.baseUrl + '/calculation/:calculationPath/update';
Object.defineProperty(postCalculationByCalculationPathUpdate, 'path', { get: _postCalculationByCalculationPathUpdatePath, set: _postCalculationByCalculationPathUpdatePath });
/** @path `/calculation/:calculationPath/update` */ 
postCalculationByCalculationPathUpdate.path = postCalculationByCalculationPathUpdate.path satisfies string;


const _postCalculationAddmanualcompensationamountByCalculationPathPath = () => defaults.baseUrl + '/calculation/addmanualcompensationamount/:calculationPath';
Object.defineProperty(postCalculationAddmanualcompensationamountByCalculationPath, 'path', { get: _postCalculationAddmanualcompensationamountByCalculationPathPath, set: _postCalculationAddmanualcompensationamountByCalculationPathPath });
/** @path `/calculation/addmanualcompensationamount/:calculationPath` */ 
postCalculationAddmanualcompensationamountByCalculationPath.path = postCalculationAddmanualcompensationamountByCalculationPath.path satisfies string;


const _postCalculationFixinterestrateByCalculationPathPath = () => defaults.baseUrl + '/calculation/fixinterestrate/:calculationPath';
Object.defineProperty(postCalculationFixinterestrateByCalculationPath, 'path', { get: _postCalculationFixinterestrateByCalculationPathPath, set: _postCalculationFixinterestrateByCalculationPathPath });
/** @path `/calculation/fixinterestrate/:calculationPath` */ 
postCalculationFixinterestrateByCalculationPath.path = postCalculationFixinterestrateByCalculationPath.path satisfies string;


const _postCreatecalculationByContractIdPath = () => defaults.baseUrl + '/createcalculation/:contractId';
Object.defineProperty(postCreatecalculationByContractId, 'path', { get: _postCreatecalculationByContractIdPath, set: _postCreatecalculationByContractIdPath });
/** @path `/createcalculation/:contractId` */ 
postCreatecalculationByContractId.path = postCreatecalculationByContractId.path satisfies string;


const _postValidatecalculationsByRequestIdPath = () => defaults.baseUrl + '/validatecalculations/:requestId';
Object.defineProperty(postValidatecalculationsByRequestId, 'path', { get: _postValidatecalculationsByRequestIdPath, set: _postValidatecalculationsByRequestIdPath });
/** @path `/validatecalculations/:requestId` */ 
postValidatecalculationsByRequestId.path = postValidatecalculationsByRequestId.path satisfies string;


const _putAddcalculationeventConversionPath = () => defaults.baseUrl + '/addcalculationevent/conversion';
Object.defineProperty(putAddcalculationeventConversion, 'path', { get: _putAddcalculationeventConversionPath, set: _putAddcalculationeventConversionPath });
/** @path `/addcalculationevent/conversion` */ 
putAddcalculationeventConversion.path = putAddcalculationeventConversion.path satisfies string;


const _putAddcalculationeventNewcreditByCalculationPathPath = () => defaults.baseUrl + '/addcalculationevent/newcredit/:calculationPath';
Object.defineProperty(putAddcalculationeventNewcreditByCalculationPath, 'path', { get: _putAddcalculationeventNewcreditByCalculationPathPath, set: _putAddcalculationeventNewcreditByCalculationPathPath });
/** @path `/addcalculationevent/newcredit/:calculationPath` */ 
putAddcalculationeventNewcreditByCalculationPath.path = putAddcalculationeventNewcreditByCalculationPath.path satisfies string;


const _putAddcalculationeventNewleasingByCalculationPathPath = () => defaults.baseUrl + '/addcalculationevent/newleasing/:calculationPath';
Object.defineProperty(putAddcalculationeventNewleasingByCalculationPath, 'path', { get: _putAddcalculationeventNewleasingByCalculationPathPath, set: _putAddcalculationeventNewleasingByCalculationPathPath });
/** @path `/addcalculationevent/newleasing/:calculationPath` */ 
putAddcalculationeventNewleasingByCalculationPath.path = putAddcalculationeventNewleasingByCalculationPath.path satisfies string;


const _putAddcalculationeventNewloanByCalculationPathPath = () => defaults.baseUrl + '/addcalculationevent/newloan/:calculationPath';
Object.defineProperty(putAddcalculationeventNewloanByCalculationPath, 'path', { get: _putAddcalculationeventNewloanByCalculationPathPath, set: _putAddcalculationeventNewloanByCalculationPathPath });
/** @path `/addcalculationevent/newloan/:calculationPath` */ 
putAddcalculationeventNewloanByCalculationPath.path = putAddcalculationeventNewloanByCalculationPath.path satisfies string;


const _postCalculationRenewinterestagreementByContractIdPath = () => defaults.baseUrl + '/calculation/renewinterestagreement/:contractId';
Object.defineProperty(postCalculationRenewinterestagreementByContractId, 'path', { get: _postCalculationRenewinterestagreementByContractIdPath, set: _postCalculationRenewinterestagreementByContractIdPath });
/** @path `/calculation/renewinterestagreement/:contractId` */ 
postCalculationRenewinterestagreementByContractId.path = postCalculationRenewinterestagreementByContractId.path satisfies string;


const _postCalculationRenewinterestagreementmultiplefixingperiodsByContractIdPath = () => defaults.baseUrl + '/calculation/renewinterestagreementmultiplefixingperiods/:contractId';
Object.defineProperty(postCalculationRenewinterestagreementmultiplefixingperiodsByContractId, 'path', { get: _postCalculationRenewinterestagreementmultiplefixingperiodsByContractIdPath, set: _postCalculationRenewinterestagreementmultiplefixingperiodsByContractIdPath });
/** @path `/calculation/renewinterestagreementmultiplefixingperiods/:contractId` */ 
postCalculationRenewinterestagreementmultiplefixingperiodsByContractId.path = postCalculationRenewinterestagreementmultiplefixingperiodsByContractId.path satisfies string;


const _putAddcalculationeventByCalculationPathExtrarepaymentPath = () => defaults.baseUrl + '/addcalculationevent/:calculationPath/extrarepayment';
Object.defineProperty(putAddcalculationeventByCalculationPathExtrarepayment, 'path', { get: _putAddcalculationeventByCalculationPathExtrarepaymentPath, set: _putAddcalculationeventByCalculationPathExtrarepaymentPath });
/** @path `/addcalculationevent/:calculationPath/extrarepayment` */ 
putAddcalculationeventByCalculationPathExtrarepayment.path = putAddcalculationeventByCalculationPathExtrarepayment.path satisfies string;


const _putAddcalculationeventByCalculationPathFullredemptionPath = () => defaults.baseUrl + '/addcalculationevent/:calculationPath/fullredemption';
Object.defineProperty(putAddcalculationeventByCalculationPathFullredemption, 'path', { get: _putAddcalculationeventByCalculationPathFullredemptionPath, set: _putAddcalculationeventByCalculationPathFullredemptionPath });
/** @path `/addcalculationevent/:calculationPath/fullredemption` */ 
putAddcalculationeventByCalculationPathFullredemption.path = putAddcalculationeventByCalculationPathFullredemption.path satisfies string;


const _putCreatenewloancalculationpathPath = () => defaults.baseUrl + '/createnewloancalculationpath';
Object.defineProperty(putCreatenewloancalculationpath, 'path', { get: _putCreatenewloancalculationpathPath, set: _putCreatenewloancalculationpathPath });
/** @path `/createnewloancalculationpath` */ 
putCreatenewloancalculationpath.path = putCreatenewloancalculationpath.path satisfies string;


const _putCreatestandalonecalculationpathPath = () => defaults.baseUrl + '/createstandalonecalculationpath';
Object.defineProperty(putCreatestandalonecalculationpath, 'path', { get: _putCreatestandalonecalculationpathPath, set: _putCreatestandalonecalculationpathPath });
/** @path `/createstandalonecalculationpath` */ 
putCreatestandalonecalculationpath.path = putCreatestandalonecalculationpath.path satisfies string;


const _putSavecalculationparametersNewloanByCalculationPathPath = () => defaults.baseUrl + '/savecalculationparameters/newloan/:calculationPath';
Object.defineProperty(putSavecalculationparametersNewloanByCalculationPath, 'path', { get: _putSavecalculationparametersNewloanByCalculationPathPath, set: _putSavecalculationparametersNewloanByCalculationPathPath });
/** @path `/savecalculationparameters/newloan/:calculationPath` */ 
putSavecalculationparametersNewloanByCalculationPath.path = putSavecalculationparametersNewloanByCalculationPath.path satisfies string;


const _getLoanparametersByCalculationPathPath = () => defaults.baseUrl + '/loanparameters/:calculationPath';
Object.defineProperty(getLoanparametersByCalculationPath, 'path', { get: _getLoanparametersByCalculationPathPath, set: _getLoanparametersByCalculationPathPath });
/** @path `/loanparameters/:calculationPath` */ 
getLoanparametersByCalculationPath.path = getLoanparametersByCalculationPath.path satisfies string;


const _putMovepayoutdateNewloanByContractIdPath = () => defaults.baseUrl + '/movepayoutdate/newloan/:contractId';
Object.defineProperty(putMovepayoutdateNewloanByContractId, 'path', { get: _putMovepayoutdateNewloanByContractIdPath, set: _putMovepayoutdateNewloanByContractIdPath });
/** @path `/movepayoutdate/newloan/:contractId` */ 
putMovepayoutdateNewloanByContractId.path = putMovepayoutdateNewloanByContractId.path satisfies string;


const _putMarkcontractasdeletedNewloanByContractIdPath = () => defaults.baseUrl + '/markcontractasdeleted/newloan/:contractId';
Object.defineProperty(putMarkcontractasdeletedNewloanByContractId, 'path', { get: _putMarkcontractasdeletedNewloanByContractIdPath, set: _putMarkcontractasdeletedNewloanByContractIdPath });
/** @path `/markcontractasdeleted/newloan/:contractId` */ 
putMarkcontractasdeletedNewloanByContractId.path = putMarkcontractasdeletedNewloanByContractId.path satisfies string;


const _getUnpaidsignedloansPath = () => defaults.baseUrl + '/unpaidsignedloans';
Object.defineProperty(getUnpaidsignedloans, 'path', { get: _getUnpaidsignedloansPath, set: _getUnpaidsignedloansPath });
/** @path `/unpaidsignedloans` */ 
getUnpaidsignedloans.path = getUnpaidsignedloans.path satisfies string;


const _getBankingdaycounttopayoutByContractIdPath = () => defaults.baseUrl + '/bankingdaycounttopayout/:contractId';
Object.defineProperty(getBankingdaycounttopayoutByContractId, 'path', { get: _getBankingdaycounttopayoutByContractIdPath, set: _getBankingdaycounttopayoutByContractIdPath });
/** @path `/bankingdaycounttopayout/:contractId` */ 
getBankingdaycounttopayoutByContractId.path = getBankingdaycounttopayoutByContractId.path satisfies string;


const _getGuarantorliabilityByContractIdPath = () => defaults.baseUrl + '/guarantorliability/:contractId';
Object.defineProperty(getGuarantorliabilityByContractId, 'path', { get: _getGuarantorliabilityByContractIdPath, set: _getGuarantorliabilityByContractIdPath });
/** @path `/guarantorliability/:contractId` */ 
getGuarantorliabilityByContractId.path = getGuarantorliabilityByContractId.path satisfies string;


const _getIscontractina360ByContractIdPath = () => defaults.baseUrl + '/iscontractina360/:contractId';
Object.defineProperty(getIscontractina360ByContractId, 'path', { get: _getIscontractina360ByContractIdPath, set: _getIscontractina360ByContractIdPath });
/** @path `/iscontractina360/:contractId` */ 
getIscontractina360ByContractId.path = getIscontractina360ByContractId.path satisfies string;


const _getExpiringagreementsPath = () => defaults.baseUrl + '/expiringagreements';
Object.defineProperty(getExpiringagreements, 'path', { get: _getExpiringagreementsPath, set: _getExpiringagreementsPath });
/** @path `/expiringagreements` */ 
getExpiringagreements.path = getExpiringagreements.path satisfies string;


const _getLoanCalculationStateBackfillStatusPath = () => defaults.baseUrl + '/loan-calculation-state-backfill/status';
Object.defineProperty(getLoanCalculationStateBackfillStatus, 'path', { get: _getLoanCalculationStateBackfillStatusPath, set: _getLoanCalculationStateBackfillStatusPath });
/** @path `/loan-calculation-state-backfill/status` */ 
getLoanCalculationStateBackfillStatus.path = getLoanCalculationStateBackfillStatus.path satisfies string;


const _postLoanCalculationStateBackfillPath = () => defaults.baseUrl + '/loan-calculation-state-backfill';
Object.defineProperty(postLoanCalculationStateBackfill, 'path', { get: _postLoanCalculationStateBackfillPath, set: _postLoanCalculationStateBackfillPath });
/** @path `/loan-calculation-state-backfill` */ 
postLoanCalculationStateBackfill.path = postLoanCalculationStateBackfill.path satisfies string;


const _postLoanDaprSigncontractdraftPath = () => defaults.baseUrl + '/LoanDapr/signcontractdraft';
Object.defineProperty(postLoanDaprSigncontractdraft, 'path', { get: _postLoanDaprSigncontractdraftPath, set: _postLoanDaprSigncontractdraftPath });
/** @path `/LoanDapr/signcontractdraft` */ 
postLoanDaprSigncontractdraft.path = postLoanDaprSigncontractdraft.path satisfies string;


const _postLoanDaprScheduledaystopayoutPath = () => defaults.baseUrl + '/LoanDapr/scheduledaystopayout';
Object.defineProperty(postLoanDaprScheduledaystopayout, 'path', { get: _postLoanDaprScheduledaystopayoutPath, set: _postLoanDaprScheduledaystopayoutPath });
/** @path `/LoanDapr/scheduledaystopayout` */ 
postLoanDaprScheduledaystopayout.path = postLoanDaprScheduledaystopayout.path satisfies string;


const _postLoanDaprDeactivatecontractdraftPath = () => defaults.baseUrl + '/LoanDapr/deactivatecontractdraft';
Object.defineProperty(postLoanDaprDeactivatecontractdraft, 'path', { get: _postLoanDaprDeactivatecontractdraftPath, set: _postLoanDaprDeactivatecontractdraftPath });
/** @path `/LoanDapr/deactivatecontractdraft` */ 
postLoanDaprDeactivatecontractdraft.path = postLoanDaprDeactivatecontractdraft.path satisfies string;


const _getPaymentnoticeGetpaymentnoticeforprocessingPath = () => defaults.baseUrl + '/paymentnotice/getpaymentnoticeforprocessing';
Object.defineProperty(getPaymentnoticeGetpaymentnoticeforprocessing, 'path', { get: _getPaymentnoticeGetpaymentnoticeforprocessingPath, set: _getPaymentnoticeGetpaymentnoticeforprocessingPath });
/** @path `/paymentnotice/getpaymentnoticeforprocessing` */ 
getPaymentnoticeGetpaymentnoticeforprocessing.path = getPaymentnoticeGetpaymentnoticeforprocessing.path satisfies string;


const _getPaymentnoticeGetpaymentnoticePath = () => defaults.baseUrl + '/paymentnotice/getpaymentnotice';
Object.defineProperty(getPaymentnoticeGetpaymentnotice, 'path', { get: _getPaymentnoticeGetpaymentnoticePath, set: _getPaymentnoticeGetpaymentnoticePath });
/** @path `/paymentnotice/getpaymentnotice` */ 
getPaymentnoticeGetpaymentnotice.path = getPaymentnoticeGetpaymentnotice.path satisfies string;


const _postPaymentnoticePostupdatenoticePath = () => defaults.baseUrl + '/paymentnotice/postupdatenotice';
Object.defineProperty(postPaymentnoticePostupdatenotice, 'path', { get: _postPaymentnoticePostupdatenoticePath, set: _postPaymentnoticePostupdatenoticePath });
/** @path `/paymentnotice/postupdatenotice` */ 
postPaymentnoticePostupdatenotice.path = postPaymentnoticePostupdatenotice.path satisfies string;


const _getRolesPath = () => defaults.baseUrl + '/_roles';
Object.defineProperty(getRoles, 'path', { get: _getRolesPath, set: _getRolesPath });
/** @path `/_roles` */ 
getRoles.path = getRoles.path satisfies string;


// }}}
 // #endregion 